<template>
  <div>
    <b-modal
      id="modal_form"
      ref="modal_form"
      size="lg"
      :title="modal_titulo"
      :ok-title="modal_botao"
      close-title="Fechar"
      v-model="showModal"
      no-close-on-esc
      no-close-on-backdrop
      :ok-disabled="form.errors.any()"
      @ok="handleOk"
    >
      <form
        @submit.stop.prevent="handleOk"
        @keydown="form.errors.clear($event.target.name)"
      >
        <b-container fluid class="p-a-0">
          <b-row>
            <b-col md="2" sm="2" class="p-0">
              <label>CST *</label>
              <multiselect
                v-model="cstSelected"
                :options="optionsParamCst"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Selecione"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('parcst_id')"
                v-if="form.errors.has('parcst_id')"
              ></b-form-feedback>
            </b-col>
            <b-col md="3" sm="3" class="p-0">
              <label>CFOP *</label>
              <multiselect
                v-model="cfopSelected"
                :options="optionsLivCfop"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Selecione"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('cfop_id')"
                v-if="form.errors.has('cfop_id')"
              ></b-form-feedback>
            </b-col>
            <b-col md="3" sm="3" class="p-0">
              <label>Tipo serviço *</label>
              <multiselect
                v-model="tpServicoSelected"
                :options="optionsLivTpServico"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Selecione"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('tp_servico')"
                v-if="form.errors.has('tp_servico')"
              ></b-form-feedback>
            </b-col>
            <b-col md="2" sm="2" class="p-0">
              <label
                >Valor Carga *
                <span
                  v-b-tooltip
                  title="Indica o valor da NF a ser utilizado no campo Valor da Carga do CTE"
                  placement="top"
                  >[?]</span
                ></label
              >
              <b-form-group>
                <b-form-radio-group
                  v-model="form.tp_valor_carga"
                  :options="optionsLivTpValorCarga"
                  name="tp_valor_carga"
                  stacked
                  plain
                ></b-form-radio-group>
              </b-form-group>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('tp_valor_carga')"
                v-if="form.errors.has('tp_valor_carga')"
              ></b-form-feedback>
            </b-col>
            <b-col md="2" sm="2" class="p-0">
              <label
                >Globalizado *
                <span
                  v-b-tooltip
                  title="Caso seja SIM, o literal diversos será usado no destinatário e vários Destinatário serão possíveis no CTE"
                  placement="top"
                  >[?]</span
                ></label
              >
              <b-form-group>
                <b-form-radio-group
                  v-model="form.globalizado"
                  :options="optionsLivGlobalizado"
                  name="globalizado"
                  stacked
                  plain
                ></b-form-radio-group>
              </b-form-group>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('globalizado')"
                v-if="form.errors.has('globalizado')"
              ></b-form-feedback>
            </b-col>
          </b-row>
          <b-row v-if="form.tp_servico == 4">
            <b-col class="p-0">
              <label>Chave CTE Multimodal</label>
              <b-form-input
                type="text"
                placeholder="Chave"
                v-model="form.chave_cte_multi"
                name="chave_cte_multi"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('chave_cte_multi')"
                v-if="form.errors.has('chave_cte_multi')"
              ></b-form-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" sm="3" class="p-0">
              <label>Municipio Inicio * </label>
              <multiselect
                v-model="municipioIniSelected"
                :options="optionsMunicipioIni"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Selecione"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('municipio_id_ini')"
                v-if="form.errors.has('municipio_id_ini')"
              ></b-form-feedback>
            </b-col>

            <b-col md="3" sm="3" class="p-0">
              <label>Municipio Fim * </label>
              <multiselect
                v-model="municipioFimSelected"
                :options="optionsMunicipioFim"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Selecione"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('municipio_id_fim')"
                v-if="form.errors.has('municipio_id_fim')"
              ></b-form-feedback>
            </b-col>

            <b-col md="6" sm="6" class="p-0">
              <label
                >Produto Predominante *
                <span
                  v-b-tooltip
                  title="Máximo de 60 caracteres"
                  placement="top"
                  >[?]</span
                >
                ( {{ produto_predominante_left }} )</label
              >
              <b-form-input
                type="text"
                placeholder="Produto Predominante"
                v-model="form.produto_predominante"
                name="cst"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('produto_predominante')"
                v-if="form.errors.has('produto_predominante')"
              ></b-form-feedback>
            </b-col>
          </b-row>
        </b-container>

        <b-container fluid class="p-a-0 pt-1">
          <b-row>
            <h3 class="header_destaque">Valores</h3>
          </b-row>
          <b-row>
            <b-col class="p-0">
              <label>Valor Liquido * </label>
              <currency-input
                class="form-control"
                v-model="form.vlr_cte"
                placeholder=""
                :auto-decimal-mode="true"
                :locale="getCurrency.locale"
                style="text-align: right"
                v-on:keyup="calcCte"
                :currency="{ prefix: 'R$ ' }"
                :distraction-free="getCurrency"
              />
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('vlr_cte')"
                v-if="form.errors.has('vlr_cte')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0">
              <label>Valor Averbação</label>
              <currency-input
                class="form-control"
                v-model="form.vlr_carga_averbacao"
                placeholder=""
                :auto-decimal-mode="true"
                :locale="getCurrency.locale"
                style="text-align: right"
                v-on:keyup="calcCte"
                :currency="{ prefix: 'R$ ' }"
                :distraction-free="getCurrency"
              />
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('vlr_carga_averbacao')"
                v-if="form.errors.has('vlr_carga_averbacao')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0">
              <label>Alíquota</label>
              <currency-input
                class="form-control"
                v-model="form.vlr_aliquota"
                placeholder=""
                :auto-decimal-mode="true"
                :locale="getCurrency.locale"
                style="text-align: right"
                v-on:keyup="calcCte"
                :currency="{ prefix: '% ' }"
                :distraction-free="getCurrency"
              />
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('vlr_aliquota')"
                v-if="form.errors.has('vlr_aliquota')"
              ></b-form-feedback>
            </b-col>
            <b-col
              class="p-0"
              v-if="this.form.cd_cst == 90 || this.form.cd_cst == 20"
            >
              <label>% Redução BC</label>
              <currency-input
                class="form-control"
                v-model="form.percentual_reducao_bc"
                placeholder=""
                :auto-decimal-mode="true"
                :locale="getCurrency.locale"
                style="text-align: right"
                v-on:keyup="calcCte"
                :currency="{ prefix: '% ' }"
                :distraction-free="getCurrency"
              />
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('percentual_reducao_bc')"
                v-if="form.errors.has('percentual_reducao_bc')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0">
              <label>Imposto</label>
              <currency-input
                class="form-control"
                v-model="form.vlr_imposto"
                placeholder=""
                disabled
                :auto-decimal-mode="true"
                :locale="getCurrency.locale"
                style="text-align: right"
                v-on:keyup="calcCte"
                :currency="{ prefix: 'R$ ' }"
                :distraction-free="getCurrency"
              />
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('vlr_imposto')"
                v-if="form.errors.has('vlr_imposto')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0">
              <label>Valor Total do CTE</label>
              <currency-input
                class="form-control"
                v-model="form.vlr_total"
                placeholder=""
                disabled
                :auto-decimal-mode="true"
                :locale="getCurrency.locale"
                style="text-align: right"
                v-on:keyup="calcCte"
                :currency="{ prefix: 'R$ ' }"
                :distraction-free="getCurrency"
              />
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('vlr_total')"
                v-if="form.errors.has('vlr_total')"
              ></b-form-feedback>
            </b-col>
          </b-row>
        </b-container>

        <b-container fluid class="p-a-0" v-if="this.form.modal == 3">
          <b-row>
            <h3 class="header_destaque">CTE <b-badge> Aquaviário </b-badge></h3>
          </b-row>
          <b-row>
            <b-col class="p-0">
              <label>Porto de Origem * </label>
              <multiselect
                v-model="portoOrigemSelected"
                :options="optionsPortoOrigem"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Selecione"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('porto_id_emb')"
                v-if="form.errors.has('porto_id_emb')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0">
              <label>Porto de Transbordo</label>
              <multiselect
                v-model="portoTransbordoSelected"
                :options="optionsPortoTransbordo"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Selecione"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('porto_id_transb')"
                v-if="form.errors.has('porto_id_transb')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0">
              <label>Porto de Destino * </label>
              <multiselect
                v-model="portoDestinoSelected"
                :options="optionsPortoDestino"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Selecione"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('porto_id_des')"
                v-if="form.errors.has('porto_id_des')"
              ></b-form-feedback>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="p-0">
              <label>Embarcação * </label>
              <multiselect
                v-model="embarcacaoSelected"
                :options="optionsEmbarcacao"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Selecione"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('embarcacao_id')"
                v-if="form.errors.has('embarcacao_id')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0">
              <label>Nº da Viagem * </label>
              <b-form-input
                type="text"
                placeholder="Nº da Viagem"
                v-model="form.num_viagem"
                name="num_viagem"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('num_viagem')"
                v-if="form.errors.has('num_viagem')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0">
              <label>% Afrmm</label>
              <currency-input
                class="form-control"
                v-model="form.vlr_aliquota_afrmm"
                placeholder=""
                :auto-decimal-mode="true"
                :locale="getCurrency.locale"
                style="text-align: right"
                v-on:keyup="calcCte"
                :currency="{ prefix: '% ' }"
                :distraction-free="getCurrency"
              />
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('vlr_aliquota_afrmm')"
                v-if="form.errors.has('vlr_aliquota_afrmm')"
              ></b-form-feedback>
            </b-col>
          </b-row>
        </b-container>
        <b-container fluid class="p-a-0" v-if="this.form.modal == 1">
          <b-row>
            <b-col class="p-0">
              <br />
              <h3 class="header_destaque">
                CTE <b-badge> Rodoviário </b-badge>
              </h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="p-0">
              <label>RNTRC * </label>
              <input
                v-model.lazy="form.rntrc"
                name="rntrc"
                type="text"
                class="form-control"
              />
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('rntrc')"
                v-if="form.errors.has('rntrc')"
              ></b-form-feedback>
            </b-col>
          </b-row>
        </b-container>
        <b-container fluid class="p-a-0" v-if="this.form.modal == 6">
          <b-row>
            <b-col class="p-0">
              <br />
              <h3 class="header_destaque">
                CTE <b-badge> Multimodal </b-badge>
              </h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="p-0">
              <label
                >COTM *
                <span
                  v-b-tooltip
                  title="Certificado de operação de transporte multimodal. Obrigatório para CTE multimodal"
                  placement="top"
                  >[?]</span
                ></label
              >
              <input
                v-model.lazy="form.cotm"
                name="cotm"
                type="text"
                class="form-control"
              />
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('cotm')"
                v-if="form.errors.has('cotm')"
              ></b-form-feedback>
            </b-col>
          </b-row>
        </b-container>
        <b-container fluid>
          <b-row>
            <b-col class="p-0">
              <br />
              <h3 class="header_destaque">Detalhes do CTE</h3>
              <b-tabs>
                <b-tab title="Partes Envolvidas" active>
                  <b-container fluid class="p-a-0">
                    <b-row>
                      <h6 class="mt-1" style="">Expedidor</h6>
                    </b-row>
                    <b-row>
                      <b-col class="p-0" md="6">
                        <label>Expedidor</label>
                        <multiselect
                          v-model="expedidorSelected"
                          :options-limit="300"
                          :limit="2"
                          :limit-text="limitText"
                          :options="optionsExpedidor"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Expedidor ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                          tag-placeholder="Selecionar"
                          select-label="Selecionar"
                          selected-label="Selecionado"
                          deselect-label="Remover"
                          :searchable="true"
                          :loading="isLoadingExp"
                          @search-change="listaClientesExpedidor"
                          :disabled="this.modal_acao == 'u'"
                        ></multiselect>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('pessoa_id_exp')"
                          v-if="form.errors.has('pessoa_id_exp')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2" sm="6">
                        <label>Inscrição Estadual </label>
                        <b-form-input
                          type="text"
                          placeholder="Inscrição Estadual"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="4">
                        <label>Endereço </label>
                        <b-form-input
                          type="text"
                          placeholder="Endereço"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>Bairro </label>
                        <b-form-input
                          type="text"
                          placeholder="Bairro"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>CEP </label>
                        <b-form-input
                          type="text"
                          placeholder="CEP"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>Email</label>
                        <b-form-input
                          type="text"
                          placeholder="Email"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>Telefone </label>
                        <b-form-input
                          type="text"
                          placeholder="Telefone"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                    </b-row>
                    <b-row>
                      <h6 class="mt-1" style="">Emitente</h6>
                    </b-row>
                    <b-row>
                      <b-col class="p-0" md="6">
                        <label>Emitente</label>
                        <multiselect
                          v-model="expedidorSelected"
                          :options-limit="300"
                          :limit="2"
                          :limit-text="limitText"
                          :options="optionsExpedidor"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Expedidor ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                          tag-placeholder="Selecionar"
                          select-label="Selecionar"
                          selected-label="Selecionado"
                          deselect-label="Remover"
                          :searchable="true"
                          :loading="isLoadingExp"
                          @search-change="listaClientesExpedidor"
                          :disabled="this.modal_acao == 'u'"
                        ></multiselect>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('pessoa_id_exp')"
                          v-if="form.errors.has('pessoa_id_exp')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2" sm="6">
                        <label>Inscrição Estadual </label>
                        <b-form-input
                          type="text"
                          placeholder="Inscrição Estadual"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="4">
                        <label>Endereço </label>
                        <b-form-input
                          type="text"
                          placeholder="Endereço"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>Bairro </label>
                        <b-form-input
                          type="text"
                          placeholder="Bairro"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>CEP </label>
                        <b-form-input
                          type="text"
                          placeholder="CEP"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>Email</label>
                        <b-form-input
                          type="text"
                          placeholder="Email"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>Telefone </label>
                        <b-form-input
                          type="text"
                          placeholder="Telefone"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                    </b-row>
                    <b-row>
                      <h6 class="mt-1" style="">Remetente</h6>
                    </b-row>
                    <b-row>
                      <b-col class="p-0" md="6">
                        <label>Remetente</label>
                        <multiselect
                          v-model="expedidorSelected"
                          :options-limit="300"
                          :limit="2"
                          :limit-text="limitText"
                          :options="optionsExpedidor"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Expedidor ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                          tag-placeholder="Selecionar"
                          select-label="Selecionar"
                          selected-label="Selecionado"
                          deselect-label="Remover"
                          :searchable="true"
                          :loading="isLoadingExp"
                          @search-change="listaClientesExpedidor"
                          :disabled="this.modal_acao == 'u'"
                        ></multiselect>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('pessoa_id_exp')"
                          v-if="form.errors.has('pessoa_id_exp')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2" sm="6">
                        <label>Inscrição Estadual </label>
                        <b-form-input
                          type="text"
                          placeholder="Inscrição Estadual"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="4">
                        <label>Endereço </label>
                        <b-form-input
                          type="text"
                          placeholder="Endereço"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>Bairro </label>
                        <b-form-input
                          type="text"
                          placeholder="Bairro"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>CEP </label>
                        <b-form-input
                          type="text"
                          placeholder="CEP"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>Email</label>
                        <b-form-input
                          type="text"
                          placeholder="Email"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>Telefone </label>
                        <b-form-input
                          type="text"
                          placeholder="Telefone"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                    </b-row>
                    <b-row>
                      <h6 class="mt-1" style="">Destinatario</h6>
                    </b-row>
                    <b-row>
                      <b-col class="p-0" md="6">
                        <label>Destinatario</label>
                        <multiselect
                          v-model="expedidorSelected"
                          :options-limit="300"
                          :limit="2"
                          :limit-text="limitText"
                          :options="optionsExpedidor"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Expedidor ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                          tag-placeholder="Selecionar"
                          select-label="Selecionar"
                          selected-label="Selecionado"
                          deselect-label="Remover"
                          :searchable="true"
                          :loading="isLoadingExp"
                          @search-change="listaClientesExpedidor"
                          :disabled="this.modal_acao == 'u'"
                        ></multiselect>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('pessoa_id_exp')"
                          v-if="form.errors.has('pessoa_id_exp')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2" sm="6">
                        <label>Inscrição Estadual </label>
                        <b-form-input
                          type="text"
                          placeholder="Inscrição Estadual"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="4">
                        <label>Endereço </label>
                        <b-form-input
                          type="text"
                          placeholder="Endereço"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>Bairro </label>
                        <b-form-input
                          type="text"
                          placeholder="Bairro"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>CEP </label>
                        <b-form-input
                          type="text"
                          placeholder="CEP"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>Email</label>
                        <b-form-input
                          type="text"
                          placeholder="Email"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>Telefone </label>
                        <b-form-input
                          type="text"
                          placeholder="Telefone"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                    </b-row>
                    <b-row>
                      <h6 class="mt-1" style="">Recebedor</h6>
                    </b-row>
                    <b-row>
                      <b-col class="p-0" md="6">
                        <label>Recebedor</label>
                        <multiselect
                          v-model="expedidorSelected"
                          :options-limit="300"
                          :limit="2"
                          :limit-text="limitText"
                          :options="optionsExpedidor"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Expedidor ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                          tag-placeholder="Selecionar"
                          select-label="Selecionar"
                          selected-label="Selecionado"
                          deselect-label="Remover"
                          :searchable="true"
                          :loading="isLoadingExp"
                          @search-change="listaClientesExpedidor"
                          :disabled="this.modal_acao == 'u'"
                        ></multiselect>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('pessoa_id_exp')"
                          v-if="form.errors.has('pessoa_id_exp')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2" sm="6">
                        <label>Inscrição Estadual </label>
                        <b-form-input
                          type="text"
                          placeholder="Inscrição Estadual"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="4">
                        <label>Endereço </label>
                        <b-form-input
                          type="text"
                          placeholder="Endereço"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>Bairro </label>
                        <b-form-input
                          type="text"
                          placeholder="Bairro"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>CEP </label>
                        <b-form-input
                          type="text"
                          placeholder="CEP"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>Email</label>
                        <b-form-input
                          type="text"
                          placeholder="Email"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="p-0" md="2">
                        <label>Telefone </label>
                        <b-form-input
                          type="text"
                          placeholder="Telefone"
                          v-model="form.num_viagem"
                          name="num_viagem"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('num_viagem')"
                          v-if="form.errors.has('num_viagem')"
                        ></b-form-feedback>
                      </b-col>
                    </b-row>
                    <b-row>
                      <h6 class="mt-1" style="">Tomador</h6>
                    </b-row>
                    <b-row>
                      <b-col class="p-0">
                        <!-- <label>Tomador</label> -->
                        <b-form-radio-group
                          v-model="form.tomador"
                          name="tomador"
                        >
                          <b-row>
                            <b-col>
                              <b-form-radio value="0"> Remetente</b-form-radio>
                            </b-col>
                            <b-col>
                              <b-form-radio value="1"> Expedidor</b-form-radio>
                            </b-col>
                            <b-col>
                              <b-form-radio value="2"> Recebedor</b-form-radio>
                            </b-col>
                            <b-col>
                              <b-form-radio value="3">
                                Destinatário</b-form-radio
                              >
                            </b-col>
                            <b-col>
                              <b-form-radio value="4"> Outros</b-form-radio>
                            </b-col>
                          </b-row>
                        </b-form-radio-group>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('tomador')"
                          v-if="form.errors.has('tomador')"
                        ></b-form-feedback>
                      </b-col>
                    </b-row>
                    <b-row v-if="form.tomador == 4">
                      <b-col class="p-0">
                        <label>Tomador - Outros</label>
                        <multiselect
                          v-model="tomadorOutrosSelected"
                          :options-limit="300"
                          :limit="2"
                          :limit-text="limitText"
                          :options="optionsTomador"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Tomador ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                          tag-placeholder="Selecionar"
                          select-label="Selecionar"
                          selected-label="Selecionado"
                          deselect-label="Remover"
                          :searchable="true"
                          :loading="isLoadingTom"
                          @search-change="listaClientesTomador"
                        ></multiselect>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('pessoa_id_tom')"
                          v-if="form.errors.has('pessoa_id_tom')"
                        ></b-form-feedback>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-tab>
                <b-tab title="Carga">
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 30%">Unidade de medida *</th>
                        <th style="width: 30%">Tipo de medida *</th>
                        <th style="width: 30%">Quantidade carga *</th>
                        <th style="width: 10%">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, index) in carga_medida"
                        class="bg-gray-light"
                        style="display: table-row"
                      >
                        <td>
                          <multiselect
                            v-model="row.parunidmed_id"
                            :options="optionsParamUnidadeMedida"
                            track-by="value"
                            label="label"
                            :hide-selected="true"
                            placeholder="Selecione"
                            tag-placeholder="Selecionar"
                            select-label="Selecionar"
                            selected-label="Selecionado"
                            deselect-label="Remover"
                          ></multiselect>
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'carga_medida.' + index + '.parunidmed_id'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'carga_medida.' + index + '.parunidmed_id'
                              )
                            "
                          ></b-form-feedback>
                        </td>
                        <td>
                          <multiselect
                            v-model="row.partpmed_id"
                            :options="optionsParamTipoMedida"
                            track-by="value"
                            label="label"
                            :hide-selected="true"
                            placeholder="Selecione"
                            tag-placeholder="Selecionar"
                            select-label="Selecionar"
                            selected-label="Selecionado"
                            deselect-label="Remover"
                          ></multiselect>
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'carga_medida.' + index + '.partpmed_id'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'carga_medida.' + index + '.partpmed_id'
                              )
                            "
                          ></b-form-feedback>
                        </td>
                        <td>
                          <currency-input
                            class="form-control"
                            v-model="row.qtde_carga"
                            placeholder=""
                            :locale="getCurrency.locale"
                            :precision="3"
                            style="text-align: right"
                            v-on:keyup="calcCte"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'carga_medida.' + index + '.qtde_carga'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'carga_medida.' + index + '.qtde_carga'
                              )
                            "
                          ></b-form-feedback>
                        </td>
                        <td>
                          <i
                            class="fa fa-times"
                            style="cursor: pointer"
                            v-b-tooltip.hover.right="'Remover Linha'"
                            v-on:click="removeRowCarga(index)"
                          ></i>
                        </td>
                      </tr>
                    </tbody>
                    <td colspan="3"></td>
                    <td>
                      <i
                        class="fa fa-plus-square"
                        v-on:click="addRowCarga($event)"
                        v-b-tooltip.hover.right="'Adicionar Linha'"
                        style="cursor: pointer"
                      ></i>
                    </td>
                  </table>
                </b-tab>
                <b-tab title="Documentos">
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th style="width: 5%">Tipo</th>
                          <th style="width: 30%">Doc Carga - Emitente</th>
                          <th style="width: 15%">Chave</th>
                          <th style="width: 10%">Nº Fiscal</th>
                          <th style="width: 10%">Série</th>
                          <th style="width: 15%">Data</th>
                          <th style="width: 5%">Ação</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="bg-gray-light"
                          style="display: table-row"
                          v-for="(row, index) in docfis"
                        >
                          <td>
                            {{ row.tp_doc_descr }}
                          </td>
                          <td>
                            {{ row.emi_nome }}
                          </td>
                          <td>
                            <span v-if="row.tp_doc_valor == 1">
                              <b-btn
                                class="badge badge-warning"
                                @click="
                                  showPopoverChaveNFe = !showPopoverChaveNFe
                                "
                                :id="'popoverButtonChaveNFe-sync' + row.chave"
                                v-b-tooltip.hover.right="
                                  'Clique aqui para ver a chave completa ( Todas )'
                                "
                                variant="warning"
                                >{{ row.chave.substr(34, 10) }}</b-btn
                              >

                              <b-popover
                                :show.sync="showPopoverChaveNFe"
                                :target="
                                  'popoverButtonChaveNFe-sync' + row.chave
                                "
                                title=""
                                data-html="true"
                                placement="top"
                              >
                                {{ row.chave }}
                              </b-popover>
                            </span>
                          </td>
                          <td>
                            {{ row.num_fiscal }}
                          </td>
                          <td>
                            {{ row.serie }}
                          </td>
                          <td>
                            <span
                              >{{ formatDate(row.dt_emissao, "DD/MM/YYYY") }}
                            </span>
                          </td>
                          <td>
                            <i
                              class="fa fa-times"
                              style="cursor: pointer"
                              v-b-tooltip.hover.right="'Remover Documento'"
                              v-on:click="removeRowDoc(index)"
                            ></i>
                          </td>
                        </tr>
                        <tr
                          class="bg-gray-light"
                          style="display: table-row"
                          v-for="(row, index) in docfisDig"
                        >
                          <td>
                            {{ row.tp_doc_descr }}
                          </td>
                          <td>
                            {{ row.emi_nome }}
                          </td>
                          <td>
                            <span v-if="row.tp_doc_valor == 1">
                              <b-btn
                                class="badge badge-warning"
                                @click="
                                  showPopoverChaveNFe = !showPopoverChaveNFe
                                "
                                :id="'popoverButtonChaveNFe-sync' + row.chave"
                                v-b-tooltip.hover.right="
                                  'Clique aqui para ver a chave completa ( Todas )'
                                "
                                variant="warning"
                                >{{ row.chave.substr(34, 10) }}</b-btn
                              >

                              <b-popover
                                :show.sync="showPopoverChaveNFe"
                                :target="
                                  'popoverButtonChaveNFe-sync' + row.chave
                                "
                                title=""
                                data-html="true"
                                placement="top"
                              >
                                {{ row.chave }}
                              </b-popover>
                            </span>
                          </td>
                          <td>
                            {{ row.num_fiscal }}
                          </td>
                          <td>
                            {{ row.serie }}
                          </td>
                          <td>
                            <span
                              >{{ formatDate(row.dt_emissao, "DD/MM/YYYY") }}
                            </span>
                          </td>
                          <td>
                            <i
                              class="fa fa-times"
                              style="cursor: pointer"
                              v-b-tooltip.hover.right="'Remover Documento'"
                              v-on:click="removeRowDocDig(index)"
                            ></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <b-tabs style="width: 100%">
                    <b-tab title="NFe" active>
                      <b-container fluid>
                        <b-row>
                          <b-col sm="10" md="10" class="m-t-5px">
                            <label>Chave NFe</label>
                            <b-form-input
                              type="text"
                              placeholder="Chave NFe"
                              v-model="helpForm.chave"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('chave')"
                              v-if="helpForm.errors.has('chave')"
                            ></b-form-feedback>
                          </b-col>
                          <b-col sm="2" md="2" class="m-t-5px pt-2">
                            <div class="float-right">
                              <b-btn
                                variant="secondary"
                                :disabled="isDisabled"
                                v-on:click="addDoc($event)"
                                v-b-tooltip.hover.right="'Adicionar NFe'"
                                style="cursor: pointer"
                              >
                                Adicionar
                              </b-btn>
                              <b-btn
                                variant="secondary"
                                :disabled="isDisabled"
                                v-on:click="onBuscarDoc()"
                                v-b-tooltip.hover.right="'Buscar Doc'"
                                style="cursor: pointer"
                              >
                                Buscar
                              </b-btn>
                            </div>
                          </b-col>
                        </b-row>
                      </b-container>
                    </b-tab>

                    <b-tab title="Digitação">
                      <b-container fluid class="p-a-0">
                        <b-row no-gutters>
                          <label><strong>Emitente Documento</strong></label>
                        </b-row>
                        <b-row no-gutters>
                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>Tipo *</label>
                            <b-form-group>
                              <b-form-radio-group
                                v-model="helpForm.emi_tp_pessoa"
                                :options="optionsLivTpPessoa"
                                plain
                                @input="ajustaMascara(1, 1)"
                              ></b-form-radio-group>
                              <!--AjustaMascara(emitente/destinatario, nfe/cte)-->
                            </b-form-group>
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('emi_tp_pessoa')"
                              v-if="helpForm.errors.has('emi_tp_pessoa')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>CNPJ/CPF</label>
                            <b-form-input
                              type="text"
                              placeholder="CNPJ/CPF"
                              v-mask="mascaraEmiNfe"
                              v-model="helpForm.emi_cnpj_cpf_cuit"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('emi_cnpj_cpf_cuit')"
                              v-if="helpForm.errors.has('emi_cnpj_cpf_cuit')"
                            ></b-form-feedback>
                          </b-col>
                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>IE</label>
                            <b-form-input
                              type="text"
                              placeholder="IE"
                              v-model="helpForm.emi_ie"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('emi_ie')"
                              v-if="helpForm.errors.has('emi_ie')"
                            ></b-form-feedback>
                          </b-col>
                          <b-col sm="6" md="6" class="m-t-5px p-a-0">
                            <label>Nome</label>
                            <b-form-input
                              type="text"
                              placeholder="Nome"
                              v-model="helpForm.emi_nome"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('emi_nome')"
                              v-if="helpForm.errors.has('emi_nome')"
                            ></b-form-feedback>
                          </b-col>
                        </b-row>
                        <div class="loadingDataPositionEndereco">
                          <div class="loadingData" v-if="loadingCepEmi">
                            <div class="loadingDataSpinner">
                              <spinner
                                v-if="loadingCepEmi"
                                text-fg-color="#ffffff"
                                message="Carregando..."
                              ></spinner>
                            </div>
                          </div>
                          <b-row no-gutters>
                            <b-col sm="2" md="2" class="m-t-5px p-a-0">
                              <label>CEP *</label>
                              <b-form-input
                                type="text"
                                placeholder="CEP"
                                @change="getCep(1)"
                                v-mask="'#####-###'"
                                v-model="helpForm.emi_cep"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="helpForm.errors.get('emi_cep')"
                                v-if="helpForm.errors.has('emi_cep')"
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="2" md="2" class="m-t-5px p-a-0">
                              <label>Municipio *</label>
                              <multiselect
                                v-model="helpForm.emi_municipio"
                                :options="optionsMunicipios"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback
                                class="text-danger"
                                v-text="
                                  helpForm.errors.get('emi_municipio.value')
                                "
                                v-if="
                                  helpForm.errors.has('emi_municipio.value')
                                "
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="3" md="3" class="m-t-5px p-a-0">
                              <label>Endereço *</label>
                              <b-form-input
                                type="text"
                                placeholder="Endereço"
                                v-model="helpForm.emi_endereco"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="helpForm.errors.get('emi_endereco')"
                                v-if="helpForm.errors.has('emi_endereco')"
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="1" md="1" class="m-t-5px p-a-0">
                              <label>Número *</label>
                              <b-form-input
                                type="text"
                                placeholder="Número"
                                v-model="helpForm.emi_numero"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="helpForm.errors.get('emi_numero')"
                                v-if="helpForm.errors.has('emi_numero')"
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="2" md="2" class="m-t-5px p-a-0">
                              <label>Bairro *</label>
                              <b-form-input
                                type="text"
                                placeholder="Bairro"
                                v-model="helpForm.emi_bairro"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="helpForm.errors.get('emi_bairro')"
                                v-if="helpForm.errors.has('emi_bairro')"
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="2" md="2" class="m-t-5px p-a-0">
                              <label>Complemento</label>
                              <b-form-input
                                type="text"
                                placeholder="Complemento"
                                v-model="helpForm.emi_complemento"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="helpForm.errors.get('emi_complemento')"
                                v-if="helpForm.errors.has('emi_complemento')"
                              ></b-form-feedback>
                            </b-col>
                          </b-row>
                        </div>
                        <b-row no-gutters>
                          <label><strong>Destinatário Documento</strong></label>
                        </b-row>
                        <b-row no-gutters>
                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>Tipo *</label>
                            <b-form-group>
                              <b-form-radio-group
                                v-model="helpForm.des_tp_pessoa"
                                :options="optionsLivTpPessoa"
                                plain
                                @input="ajustaMascara(2, 1)"
                              ></b-form-radio-group>
                              <!--AjustaMascara(emitente/destinatario, nfe/cte)-->
                            </b-form-group>
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('des_tp_pessoa')"
                              v-if="helpForm.errors.has('des_tp_pessoa')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>CNPJ/CPF</label>
                            <b-form-input
                              type="text"
                              placeholder="CNPJ/CPF"
                              v-mask="mascaraDesNfe"
                              v-model="helpForm.des_cnpj_cpf_cuit"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('des_cnpj_cpf_cuit')"
                              v-if="helpForm.errors.has('des_cnpj_cpf_cuit')"
                            ></b-form-feedback>
                          </b-col>
                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>IE</label>
                            <b-form-input
                              type="text"
                              placeholder="IE"
                              v-model="helpForm.des_ie"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('des_ie')"
                              v-if="helpForm.errors.has('des_ie')"
                            ></b-form-feedback>
                          </b-col>
                          <b-col sm="4" md="4" class="m-t-5px p-a-0">
                            <label>Nome</label>
                            <b-form-input
                              type="text"
                              placeholder="Nome"
                              v-model="helpForm.des_nome"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('des_nome')"
                              v-if="helpForm.errors.has('des_nome')"
                            ></b-form-feedback>
                          </b-col>
                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>PIN Suframa</label>
                            <b-form-input
                              type="text"
                              placeholder="PIN"
                              v-model="helpForm.des_pin"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('des_pin')"
                              v-if="helpForm.errors.has('des_pin')"
                            ></b-form-feedback>
                          </b-col>
                        </b-row>
                        <div class="loadingDataPositionEndereco">
                          <div class="loadingData" v-if="loadingCepDes">
                            <div class="loadingDataSpinner">
                              <spinner
                                v-if="loadingCepDes"
                                text-fg-color="#ffffff"
                                message="Carregando..."
                              ></spinner>
                            </div>
                          </div>
                          <b-row no-gutters>
                            <b-col sm="2" md="2" class="m-t-5px p-a-0">
                              <label>CEP *</label>
                              <b-form-input
                                type="text"
                                placeholder="CEP"
                                @change="getCep(2)"
                                v-mask="'#####-###'"
                                v-model="helpForm.des_cep"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="helpForm.errors.get('des_cep')"
                                v-if="helpForm.errors.has('des_cep')"
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="2" md="2" class="m-t-5px p-a-0">
                              <label>Municipio *</label>
                              <multiselect
                                v-model="helpForm.des_municipio"
                                :options="optionsMunicipios"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback
                                class="text-danger"
                                v-text="
                                  helpForm.errors.get('des_municipio.value')
                                "
                                v-if="
                                  helpForm.errors.has('des_municipio.value')
                                "
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="3" md="3" class="m-t-5px p-a-0">
                              <label>Endereço *</label>
                              <b-form-input
                                type="text"
                                placeholder="Endereço"
                                v-model="helpForm.des_endereco"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="helpForm.errors.get('des_endereco')"
                                v-if="helpForm.errors.has('des_endereco')"
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="1" md="1" class="m-t-5px p-a-0">
                              <label>Número *</label>
                              <b-form-input
                                type="text"
                                placeholder="Número"
                                v-model="helpForm.des_numero"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="helpForm.errors.get('des_numero')"
                                v-if="helpForm.errors.has('des_numero')"
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="2" md="2" class="m-t-5px p-a-0">
                              <label>Bairro *</label>
                              <b-form-input
                                type="text"
                                placeholder="Bairro"
                                v-model="helpForm.des_bairro"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="helpForm.errors.get('des_bairro')"
                                v-if="helpForm.errors.has('des_bairro')"
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="2" md="2" class="m-t-5px p-a-0">
                              <label>Complemento</label>
                              <b-form-input
                                type="text"
                                placeholder="Complemento"
                                v-model="helpForm.des_complemento"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="helpForm.errors.get('des_complemento')"
                                v-if="helpForm.errors.has('des_complemento')"
                              ></b-form-feedback>
                            </b-col>
                          </b-row>
                        </div>

                        <b-row no-gutters>
                          <label><strong>Detalhes</strong></label>
                        </b-row>
                        <b-row no-gutters>
                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>Tipo *</label>
                            <multiselect
                              v-model="helpForm.tp_doc"
                              :options="optionsLivDocFiscalTpDoc"
                              track-by="value"
                              label="label"
                              :hide-selected="true"
                              placeholder="Selecione"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('tp_doc.value')"
                              v-if="helpForm.errors.has('tp_doc.value')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="1" md="1" class="m-t-5px p-a-0">
                            <label>Nº Fiscal *</label>
                            <b-form-input
                              type="text"
                              placeholder="Nº Fiscal"
                              v-model="helpForm.num_fiscal"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('num_fiscal')"
                              v-if="helpForm.errors.has('num_fiscal')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="1" md="1" class="m-t-5px p-a-0">
                            <label>Série *</label>
                            <b-form-input
                              type="text"
                              placeholder="Série"
                              v-model="helpForm.serie"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('serie')"
                              v-if="helpForm.errors.has('serie')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="1" md="1" class="m-t-5px p-a-0">
                            <label>Chave</label>
                            <b-form-input
                              type="text"
                              placeholder="Chave"
                              v-model="helpForm.chave"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('chave')"
                              v-if="helpForm.errors.has('chave')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>Data *</label>
                            <input
                              type="text"
                              placeholder="Data"
                              class="form-control"
                              v-mask="'##/##/####'"
                              v-model="helpForm.dt_emissao"
                              @keyup.enter="doFilter"
                            />
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('dt_emissao')"
                              v-if="helpForm.errors.has('dt_emissao')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="1" md="1" class="m-t-5px p-a-0">
                            <label>Volume *</label>
                            <b-form-input
                              type="text"
                              placeholder="Volume"
                              v-model="helpForm.qtd_volume"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('qtd_volume')"
                              v-if="helpForm.errors.has('qtd_volume')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>Peso Bruto *</label>
                            <currency-input
                              class="form-control"
                              v-model="helpForm.peso_bruto"
                              placeholder=""
                              :precision="3"
                              :locale="getCurrency.locale"
                              style="text-align: right"
                              v-on:keyup="calcCte"
                              :currency="{ prefix: 'KG ' }"
                              :distraction-free="getCurrency"
                            />
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('peso_bruto')"
                              v-if="helpForm.errors.has('peso_bruto')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>Valor Doc. *</label>
                            <currency-input
                              class="form-control"
                              v-model="helpForm.vlr_total_nfe"
                              placeholder=""
                              :auto-decimal-mode="true"
                              :locale="getCurrency.locale"
                              style="text-align: right"
                              v-on:keyup="calcCte"
                              :currency="{ prefix: 'R$ ' }"
                              :distraction-free="getCurrency"
                            />
                            <b-form-feedback
                              class="text-danger"
                              v-text="helpForm.errors.get('vlr_total_nfe')"
                              v-if="helpForm.errors.has('vlr_total_nfe')"
                            ></b-form-feedback>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col sm="10" md="10"> </b-col>
                          <b-col sm="2" md="2" class="text-right">
                            <b-btn
                              variant="secondary"
                              :disabled="isDisabled"
                              v-on:click="addDocDigitacao($event)"
                              v-b-tooltip.hover.right="'Adicionar Documento'"
                              style="cursor: pointer"
                            >
                              Adicionar
                            </b-btn>
                          </b-col>
                        </b-row>
                      </b-container>
                    </b-tab>
                  </b-tabs>
                </b-tab>
                <b-tab title="Seguro">
                  <div class="table">
                    <table class="table">
                      <thead>
                        <tr>
                          <th style="width: 45%">Responsável pelo seguro</th>
                          <th style="width: 45%">Seguradora</th>
                          <th style="width: 5%">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(row, index) in seguro"
                          class="bg-gray-light"
                          style="display: table-row"
                        >
                          <td>
                            <b-col class="p-0">
                              <multiselect
                                v-model="row.partprese_id"
                                :options="optionsParamRespSeg"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback
                                class="text-danger"
                                v-text="
                                  form.errors.get(
                                    'seguro.' + index + '.partprese_id'
                                  )
                                "
                                v-if="
                                  form.errors.has(
                                    'seguro.' + index + '.partprese_id'
                                  )
                                "
                              ></b-form-feedback>
                            </b-col>
                          </td>
                          <td>
                            <multiselect
                              v-model="row.segurado_id"
                              :options="optionsSeguradora"
                              track-by="value"
                              label="label"
                              :hide-selected="true"
                              placeholder="Selecione"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                            <b-form-feedback
                              class="text-danger"
                              v-text="
                                form.errors.get(
                                  'seguro.' + index + '.segurado_id'
                                )
                              "
                              v-if="
                                form.errors.has(
                                  'seguro.' + index + '.segurado_id'
                                )
                              "
                            ></b-form-feedback>
                          </td>
                          <td>
                            <i
                              class="fa fa-times"
                              style="cursor: pointer"
                              v-b-tooltip.hover.right="'Remover Linha'"
                              v-on:click="removeRowSeguro(index)"
                            ></i>
                          </td>
                        </tr>
                      </tbody>
                      <td></td>
                      <td></td>
                      <td>
                        <i
                          class="fa fa-plus-square"
                          v-on:click="addRowSeguro($event)"
                          v-b-tooltip.hover.right="'Adicionar Linha'"
                          style="cursor: pointer"
                        ></i>
                      </td>
                    </table>
                  </div>
                </b-tab>
                <b-tab title="Observações">
                  <h3 class="header_destaque">Observação geral</h3>
                  <b-form-textarea
                    id="textarea1"
                    name="obs"
                    v-model="form.obs"
                    placeholder="Observação"
                    :rows="6"
                    :max-rows="6"
                  >
                  </b-form-textarea>
                  <label>( {{ obs_left }} )</label>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('obs')"
                    v-if="form.errors.has('obs')"
                  ></b-form-feedback>
                  <h3 class="header_destaque">Campos livres contribuinte</h3>
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 45%">Campo</th>
                        <th style="width: 45%">Valor</th>
                        <th style="width: 10%">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in obs_cont">
                        <td>
                          <b-col class="p-0">
                            <b-form-input
                              type="text"
                              placeholder="Descrição"
                              v-model="row.xcampo"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="
                                form.errors.get('obs_cont.' + index + '.xcampo')
                              "
                              v-if="
                                form.errors.has('obs_cont.' + index + '.xcampo')
                              "
                            ></b-form-feedback>
                          </b-col>
                        </td>
                        <td>
                          <b-col class="p-0">
                            <b-form-input
                              type="text"
                              placeholder="Valor"
                              v-model="row.xtexto"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="
                                form.errors.get('obs_cont.' + index + '.xtexto')
                              "
                              v-if="
                                form.errors.has('obs_cont.' + index + '.xtexto')
                              "
                            ></b-form-feedback>
                          </b-col>
                        </td>
                        <td>
                          <i
                            class="fa fa-times"
                            style="cursor: pointer"
                            v-b-tooltip.hover.right="'Remover Linha'"
                            v-on:click="removeRowObsCont(index)"
                          ></i>
                        </td>
                      </tr>
                    </tbody>
                    <td></td>
                    <td></td>
                    <td>
                      <i
                        class="fa fa-plus-square"
                        v-on:click="addRowObsCont($event)"
                        v-b-tooltip.hover.right="'Adicionar Linha'"
                        style="cursor: pointer"
                      ></i>
                    </td>
                  </table>
                  <h3 class="header_destaque">Campos livres fisco</h3>
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 45%">Campo</th>
                        <th style="width: 45%">Valor</th>
                        <th style="width: 10%">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in obs_fisco">
                        <td>
                          <b-col class="p-0">
                            <b-form-input
                              type="text"
                              placeholder="Descrição"
                              v-model="row.xcampo"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="
                                form.errors.get(
                                  'obs_fisco.' + index + '.xcampo'
                                )
                              "
                              v-if="
                                form.errors.has(
                                  'obs_fisco.' + index + '.xcampo'
                                )
                              "
                            ></b-form-feedback>
                          </b-col>
                        </td>
                        <td>
                          <b-col class="p-0">
                            <b-form-input
                              type="text"
                              placeholder="Valor"
                              v-model="row.xtexto"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="
                                form.errors.get(
                                  'obs_fisco.' + index + '.xtexto'
                                )
                              "
                              v-if="
                                form.errors.has(
                                  'obs_fisco.' + index + '.xtexto'
                                )
                              "
                            ></b-form-feedback>
                          </b-col>
                        </td>
                        <td>
                          <i
                            class="fa fa-times"
                            style="cursor: pointer"
                            v-b-tooltip.hover.right="'Remover Linha'"
                            v-on:click="removeRowObsFisco(index)"
                          ></i>
                        </td>
                      </tr>
                    </tbody>
                    <td></td>
                    <td></td>
                    <td>
                      <i
                        class="fa fa-plus-square"
                        v-on:click="addRowObsFisco($event)"
                        v-b-tooltip.hover.right="'Adicionar Linha'"
                        style="cursor: pointer"
                      ></i>
                    </td>
                  </table>
                </b-tab>
                <b-tab title="Comp. Frete">
                  <div class="table">
                    <table class="table">
                      <thead>
                        <tr>
                          <th style="width: 45%">Componente *</th>
                          <th style="width: 45%">Valor *</th>
                          <th style="width: 10%">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in comp_frete">
                          <td>
                            <multiselect
                              v-model="row.custo_id"
                              :options="optionsCustos"
                              track-by="value"
                              label="label"
                              :hide-selected="true"
                              placeholder="Selecione"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                            <b-form-feedback
                              class="text-danger"
                              v-text="
                                form.errors.get(
                                  'comp_frete.' + index + '.custo_id'
                                )
                              "
                              v-if="
                                form.errors.has(
                                  'comp_frete.' + index + '.custo_id'
                                )
                              "
                            ></b-form-feedback>
                          </td>
                          <td>
                            <b-col class="p-0">
                              <currency-input
                                class="form-control"
                                v-model="row.vlr"
                                placeholder=""
                                :precision="2"
                                :locale="getCurrency.locale"
                                style="text-align: right"
                                v-on:keyup="calcCte"
                                :currency="{ prefix: 'R$ ' }"
                                :distraction-free="getCurrency"
                              />
                              <b-form-feedback
                                class="text-danger"
                                v-text="
                                  form.errors.get(
                                    'comp_frete.' + index + '.vlr'
                                  )
                                "
                                v-if="
                                  form.errors.has(
                                    'comp_frete.' + index + '.vlr'
                                  )
                                "
                              ></b-form-feedback>
                            </b-col>
                          </td>
                          <td>
                            <i
                              class="fa fa-times"
                              style="cursor: pointer"
                              v-b-tooltip.hover.right="'Remover Linha'"
                              v-on:click="removeRowCompFrete(index)"
                            ></i>
                          </td>
                        </tr>
                      </tbody>
                      <td></td>
                      <td></td>
                      <td>
                        <i
                          class="fa fa-plus-square"
                          v-on:click="addRowCompFrete($event)"
                          v-b-tooltip.hover.right="'Adicionar Linha'"
                          style="cursor: pointer"
                        ></i>
                      </td>
                    </table>
                  </div>
                </b-tab>
                <b-tab title="Documentos Anteriores">
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th style="width: 5%">Tipo</th>
                          <th style="width: 30%">Doc Anterior - Emitente</th>
                          <th style="width: 15%">Chave</th>
                          <th style="width: 10%">Nº Fiscal</th>
                          <th style="width: 10%">Série</th>
                          <th style="width: 15%">Data</th>
                          <th style="width: 5%">Ação</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="bg-gray-light"
                          style="display: table-row"
                          v-for="(row, index) in doctransp"
                        >
                          <td>
                            {{ row.tp_doc_descr }}
                          </td>
                          <td>
                            {{ row.emi_nome }}
                          </td>
                          <td>
                            <span v-if="row.tp_doc_valor == 1">
                              <b-btn
                                class="badge badge-warning"
                                @click="
                                  showPopoverChaveCTe = !showPopoverChaveCTe
                                "
                                :id="'popoverButtonChaveCTe-sync' + row.chave"
                                v-b-tooltip.hover.right="
                                  'Clique aqui para ver a chave completa ( Todas )'
                                "
                                variant="warning"
                                >{{ row.chave.substr(34, 10) }}</b-btn
                              >

                              <b-popover
                                :show.sync="showPopoverChaveCTe"
                                :target="
                                  'popoverButtonChaveCTe-sync' + row.chave
                                "
                                title=""
                                data-html="true"
                                placement="top"
                              >
                                {{ row.chave }}
                              </b-popover>
                            </span>
                          </td>
                          <td>
                            {{ row.num_fiscal }}
                          </td>
                          <td>
                            {{ row.serie }}
                          </td>
                          <td>
                            <span
                              >{{ formatDate(row.dt_emissao, "DD/MM/YYYY") }}
                            </span>
                          </td>
                          <td>
                            <i
                              class="fa fa-times"
                              style="cursor: pointer"
                              v-b-tooltip.hover.right="'Remover Documento'"
                              v-on:click="removeRowDocTransp(index)"
                            ></i>
                          </td>
                        </tr>
                        <tr
                          class="bg-gray-light"
                          style="display: table-row"
                          v-for="(row, index) in doctranspDig"
                        >
                          <td>
                            {{ row.tp_doc_descr }}
                          </td>
                          <td>
                            {{ row.emi_nome }}
                          </td>
                          <td>
                            <span v-if="row.tp_doc_valor == 1">
                              <b-btn
                                class="badge badge-warning"
                                @click="
                                  showPopoverChaveCTe = !showPopoverChaveCTe
                                "
                                :id="'popoverButtonChaveCTe-sync' + row.chave"
                                v-b-tooltip.hover.right="
                                  'Clique aqui para ver a chave completa ( Todas )'
                                "
                                variant="warning"
                                >{{ row.chave.substr(34, 10) }}</b-btn
                              >

                              <b-popover
                                :show.sync="showPopoverChaveCTe"
                                :target="
                                  'popoverButtonChaveCTe-sync' + row.chave
                                "
                                title=""
                                data-html="true"
                                placement="top"
                              >
                                {{ row.chave }}
                              </b-popover>
                            </span>
                          </td>
                          <td>
                            {{ row.num_fiscal }}
                          </td>
                          <td>
                            {{ row.serie }}
                          </td>
                          <td>
                            <span
                              >{{ formatDate(row.dt_emissao, "DD/MM/YYYY") }}
                            </span>
                          </td>
                          <td>
                            <i
                              class="fa fa-times"
                              style="cursor: pointer"
                              v-b-tooltip.hover.right="'Remover Documento'"
                              v-on:click="removeRowDocTranspDig(index)"
                            ></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <b-tabs style="width: 100%">
                    <b-tab title="CTe" active>
                      <b-container fluid>
                        <b-row>
                          <b-col sm="10" md="10" class="m-t-5px">
                            <label>Chave CTe</label>
                            <b-form-input
                              type="text"
                              placeholder="Chave CTe"
                              v-model="form_doctransp.chave"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="form_doctransp.errors.get('chave')"
                              v-if="form_doctransp.errors.has('chave')"
                            ></b-form-feedback>
                          </b-col>
                          <b-col sm="2" md="2" class="m-t-5px pt-2">
                            <b-btn
                              variant="secondary"
                              :disabled="isDisabled"
                              v-on:click="addDocTransp($event)"
                              v-b-tooltip.hover.right="'Adicionar CTe'"
                              style="cursor: pointer"
                            >
                              Adicionar
                            </b-btn>
                          </b-col>
                        </b-row>
                      </b-container>
                    </b-tab>

                    <b-tab title="Digitação">
                      <b-container fluid class="p-a-0">
                        <b-row no-gutters>
                          <label><strong>Emitente Documento</strong></label>
                        </b-row>
                        <b-row no-gutters>
                          <b-col sm="3" md="3" class="m-t-5px p-a-0">
                            <label>CNPJ</label>
                            <b-form-input
                              type="text"
                              placeholder="CNPJ"
                              v-mask="'NN.NNN.NNN/NNNN-NN'"
                              v-model="form_doctransp.emi_cnpj_cpf_cuit"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="
                                form_doctransp.errors.get('emi_cnpj_cpf_cuit')
                              "
                              v-if="
                                form_doctransp.errors.has('emi_cnpj_cpf_cuit')
                              "
                            ></b-form-feedback>
                          </b-col>
                          <b-col sm="9" md="9" class="m-t-5px p-a-0">
                            <label>Nome</label>
                            <b-form-input
                              type="text"
                              placeholder="Nome"
                              v-model="form_doctransp.emi_nome"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="form_doctransp.errors.get('emi_nome')"
                              v-if="form_doctransp.errors.has('emi_nome')"
                            ></b-form-feedback>
                          </b-col>
                        </b-row>
                        <div class="loadingDataPositionEndereco">
                          <div class="loadingData" v-if="loadingCepEmi">
                            <div class="loadingDataSpinner">
                              <spinner
                                v-if="loadingCepEmi"
                                text-fg-color="#ffffff"
                                message="Carregando..."
                              ></spinner>
                            </div>
                          </div>
                          <b-row no-gutters>
                            <b-col sm="2" md="2" class="m-t-5px p-a-0">
                              <label>CEP *</label>
                              <b-form-input
                                type="text"
                                placeholder="CEP"
                                @change="getCep(3)"
                                v-model="form_doctransp.emi_cep"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="form_doctransp.errors.get('emi_cep')"
                                v-if="form_doctransp.errors.has('emi_cep')"
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="2" md="2" class="m-t-5px p-a-0">
                              <label>Municipio *</label>
                              <multiselect
                                v-model="form_doctransp.emi_municipio"
                                :options="optionsMunicipios"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback
                                class="text-danger"
                                v-text="
                                  form_doctransp.errors.get(
                                    'emi_municipio.value'
                                  )
                                "
                                v-if="
                                  form_doctransp.errors.has(
                                    'emi_municipio.value'
                                  )
                                "
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="3" md="3" class="m-t-5px p-a-0">
                              <label>Endereço *</label>
                              <b-form-input
                                type="text"
                                placeholder="Endereço"
                                v-model="form_doctransp.emi_endereco"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="
                                  form_doctransp.errors.get('emi_endereco')
                                "
                                v-if="form_doctransp.errors.has('emi_endereco')"
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="1" md="1" class="m-t-5px p-a-0">
                              <label>Número *</label>
                              <b-form-input
                                type="text"
                                placeholder="Número"
                                v-model="form_doctransp.emi_numero"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="form_doctransp.errors.get('emi_numero')"
                                v-if="form_doctransp.errors.has('emi_numero')"
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="2" md="2" class="m-t-5px p-a-0">
                              <label>Bairro *</label>
                              <b-form-input
                                type="text"
                                placeholder="Bairro"
                                v-model="form_doctransp.emi_bairro"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="form_doctransp.errors.get('emi_bairro')"
                                v-if="form_doctransp.errors.has('emi_bairro')"
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="2" md="2" class="m-t-5px p-a-0">
                              <label>Complemento</label>
                              <b-form-input
                                type="text"
                                placeholder="Complemento"
                                v-model="form_doctransp.emi_complemento"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="
                                  form_doctransp.errors.get('emi_complemento')
                                "
                                v-if="
                                  form_doctransp.errors.has('emi_complemento')
                                "
                              ></b-form-feedback>
                            </b-col>
                          </b-row>
                        </div>
                        <b-row no-gutters>
                          <label><strong>Destinatário Documento</strong></label>
                        </b-row>
                        <b-row no-gutters>
                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>Tipo *</label>
                            <b-form-group>
                              <b-form-radio-group
                                v-model="form_doctransp.des_tp_pessoa"
                                @input="ajustaMascara(2, 2)"
                                :options="optionsLivTpPessoa"
                                plain
                              ></b-form-radio-group>
                              <!--AjustaMascara(emitente/destinatario, nfe/cte)-->
                            </b-form-group>
                            <b-form-feedback
                              class="text-danger"
                              v-text="
                                form_doctransp.errors.get('des_tp_pessoa')
                              "
                              v-if="form_doctransp.errors.has('des_tp_pessoa')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>CNPJ/CPF</label>
                            <b-form-input
                              type="text"
                              placeholder="CNPJ/CPF"
                              v-model="form_doctransp.des_cnpj_cpf_cuit"
                              v-mask="mascaraDesCte"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="
                                form_doctransp.errors.get('des_cnpj_cpf_cuit')
                              "
                              v-if="
                                form_doctransp.errors.has('des_cnpj_cpf_cuit')
                              "
                            ></b-form-feedback>
                          </b-col>
                          <b-col sm="6" md="6" class="m-t-5px p-a-0">
                            <label>Nome</label>
                            <b-form-input
                              type="text"
                              placeholder="Nome"
                              v-model="form_doctransp.des_nome"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="form_doctransp.errors.get('des_nome')"
                              v-if="form_doctransp.errors.has('des_nome')"
                            ></b-form-feedback>
                          </b-col>
                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>PIN Suframa</label>
                            <b-form-input
                              type="text"
                              placeholder="PIN"
                              v-model="form_doctransp.des_pin"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="form_doctransp.errors.get('des_pin')"
                              v-if="form_doctransp.errors.has('des_pin')"
                            ></b-form-feedback>
                          </b-col>
                        </b-row>
                        <div class="loadingDataPositionEndereco">
                          <div class="loadingData" v-if="loadingCepDes">
                            <div class="loadingDataSpinner">
                              <spinner
                                v-if="loadingCepDes"
                                text-fg-color="#ffffff"
                                message="Carregando..."
                              ></spinner>
                            </div>
                          </div>
                          <b-row no-gutters>
                            <b-col sm="2" md="2" class="m-t-5px p-a-0">
                              <label>CEP *</label>
                              <b-form-input
                                type="text"
                                placeholder="CEP"
                                @change="getCep(4)"
                                v-model="form_doctransp.des_cep"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="form_doctransp.errors.get('des_cep')"
                                v-if="form_doctransp.errors.has('des_cep')"
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="2" md="2" class="m-t-5px p-a-0">
                              <label>Municipio *</label>
                              <multiselect
                                v-model="form_doctransp.des_municipio"
                                :options="optionsMunicipios"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback
                                class="text-danger"
                                v-text="
                                  form_doctransp.errors.get(
                                    'des_municipio.value'
                                  )
                                "
                                v-if="
                                  form_doctransp.errors.has(
                                    'des_municipio.value'
                                  )
                                "
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="3" md="3" class="m-t-5px p-a-0">
                              <label>Endereço *</label>
                              <b-form-input
                                type="text"
                                placeholder="Endereço"
                                v-model="form_doctransp.des_endereco"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="
                                  form_doctransp.errors.get('des_endereco')
                                "
                                v-if="form_doctransp.errors.has('des_endereco')"
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="1" md="1" class="m-t-5px p-a-0">
                              <label>Número *</label>
                              <b-form-input
                                type="text"
                                placeholder="Número"
                                v-model="form_doctransp.des_numero"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="form_doctransp.errors.get('des_numero')"
                                v-if="form_doctransp.errors.has('des_numero')"
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="2" md="2" class="m-t-5px p-a-0">
                              <label>Bairro *</label>
                              <b-form-input
                                type="text"
                                placeholder="Bairro"
                                v-model="form_doctransp.des_bairro"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="form_doctransp.errors.get('des_bairro')"
                                v-if="form_doctransp.errors.has('des_bairro')"
                              ></b-form-feedback>
                            </b-col>

                            <b-col sm="2" md="2" class="m-t-5px p-a-0">
                              <label>Complemento</label>
                              <b-form-input
                                type="text"
                                placeholder="Complemento"
                                v-model="form_doctransp.des_complemento"
                              >
                              </b-form-input>
                              <b-form-feedback
                                class="text-danger"
                                v-text="
                                  form_doctransp.errors.get('des_complemento')
                                "
                                v-if="
                                  form_doctransp.errors.has('des_complemento')
                                "
                              ></b-form-feedback>
                            </b-col>
                          </b-row>
                        </div>
                        <b-row no-gutters>
                          <label><strong>Detalhes</strong></label>
                        </b-row>
                        <b-row no-gutters>
                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>Tipo *</label>
                            <multiselect
                              v-model="form_doctransp.tp_doc"
                              :options="optionsLivDocTranspTpDoc"
                              track-by="value"
                              label="label"
                              :hide-selected="true"
                              placeholder="Selecione"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                            <b-form-feedback
                              class="text-danger"
                              v-text="form_doctransp.errors.get('tp_doc.value')"
                              v-if="form_doctransp.errors.has('tp_doc.value')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="1" md="1" class="m-t-5px p-a-0">
                            <label>Nº Fiscal *</label>
                            <b-form-input
                              type="text"
                              placeholder="Nº Fiscal"
                              v-model="form_doctransp.num_fiscal"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="form_doctransp.errors.get('num_fiscal')"
                              v-if="form_doctransp.errors.has('num_fiscal')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="1" md="1" class="m-t-5px p-a-0">
                            <label>Série *</label>
                            <b-form-input
                              type="text"
                              placeholder="Série"
                              v-model="form_doctransp.serie"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="form_doctransp.errors.get('serie')"
                              v-if="form_doctransp.errors.has('serie')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="1" md="1" class="m-t-5px p-a-0">
                            <label>Chave</label>
                            <b-form-input
                              type="text"
                              placeholder="Chave"
                              v-model="form_doctransp.chave"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="form_doctransp.errors.get('chave')"
                              v-if="form_doctransp.errors.has('chave')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>Data *</label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Data"
                              v-mask="'##/##/####'"
                              v-model="form_doctransp.dt_emissao"
                              @keyup.enter="doFilter"
                            />
                            <b-form-feedback
                              class="text-danger"
                              v-text="form_doctransp.errors.get('dt_emissao')"
                              v-if="form_doctransp.errors.has('dt_emissao')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="1" md="1" class="m-t-5px p-a-0">
                            <label>Volume *</label>
                            <b-form-input
                              type="text"
                              placeholder="Volume"
                              v-model="form_doctransp.qtd_volume"
                            >
                            </b-form-input>
                            <b-form-feedback
                              class="text-danger"
                              v-text="form_doctransp.errors.get('qtd_volume')"
                              v-if="form_doctransp.errors.has('qtd_volume')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>Peso Bruto *</label>
                            <currency-input
                              class="form-control"
                              v-model="form_doctransp.peso_bruto"
                              placeholder=""
                              :precision="3"
                              :locale="getCurrency.locale"
                              style="text-align: right"
                              v-on:keyup="calcCte"
                              :currency="{ prefix: 'KG ' }"
                              :distraction-free="getCurrency"
                            />
                            <b-form-feedback
                              class="text-danger"
                              v-text="form_doctransp.errors.get('peso_bruto')"
                              v-if="form_doctransp.errors.has('peso_bruto')"
                            ></b-form-feedback>
                          </b-col>

                          <b-col sm="2" md="2" class="m-t-5px p-a-0">
                            <label>Valor Doc. *</label>
                            <currency-input
                              class="form-control"
                              v-model="form_doctransp.vlr_total_cte"
                              placeholder=""
                              :auto-decimal-mode="true"
                              :locale="getCurrency.locale"
                              style="text-align: right"
                              v-on:keyup="calcCte"
                              :currency="{ prefix: 'R$ ' }"
                              :distraction-free="getCurrency"
                            />
                            <b-form-feedback
                              class="text-danger"
                              v-text="
                                form_doctransp.errors.get('vlr_total_cte')
                              "
                              v-if="form_doctransp.errors.has('vlr_total_cte')"
                            ></b-form-feedback>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col sm="10" md="10"> </b-col>
                          <b-col sm="2" md="2" class="text-right">
                            <b-btn
                              variant="secondary"
                              :disabled="isDisabled"
                              v-on:click="addDocTranspDigitacao($event)"
                              v-b-tooltip.hover.right="'Adicionar Documento'"
                              style="cursor: pointer"
                            >
                              Adicionar
                            </b-btn>
                          </b-col>
                        </b-row>
                      </b-container>
                    </b-tab>
                  </b-tabs>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-container>
      </form>

      <div slot="modal-footer" class="w-100">
        <div class="float-left">
          <spinner v-if="loading" message="Processando..."></spinner>
          <spinner v-if="loadingCep" message="buscando endereço..."></spinner>
          <spinner
            v-if="loadingAddDoc"
            message="buscando documento..."
          ></spinner>
        </div>
        <div class="float-right">
          <div class="float-left" v-if="this.errors_array.length > 0">
            <b-btn
              class="badge badge-warning"
              @click="showPopover = !showPopover"
              id="popoverButton-sync"
              v-b-tooltip.hover.left="
                'Clique aqui para ver os erros encontrados'
              "
              variant="warning"
              ><i class="fa fa-exclamation-triangle fa-2x"></i
            ></b-btn>

            <b-popover
              :show.sync="showPopover"
              target="popoverButton-sync"
              title="<strong>Erros Encontrados</strong>"
              data-html="true"
              placement="leftbottom"
            >
              <table class="table" id="mais">
                <tbody>
                  <tr
                    class="bg-gray-light"
                    style="display: table-row"
                    v-for="item in this.errors_array"
                  >
                    <td>
                      {{ item.erro }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-popover>
          </div>
          &nbsp;

          <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
          <b-btn
            @click="handleOk($event)"
            variant="secondary"
            :disabled="isDisabled"
          >
            Enviar
          </b-btn>
        </div>
      </div>
    </b-modal>
    <BuscarDocFiscal ref="buscardocfiscal"> </BuscarDocFiscal>
    <EditarDocFiscal ref="editardocfiscal"> </EditarDocFiscal>
  </div>
</template>
<script>
import accounting from "accounting";
import moment from "moment";
import BuscarDocFiscal from "../components/BuscarDocFiscal";
import EditarDocFiscal from "../components/EditarDocFiscal";

import { formatCNPJFromParts } from "../utils";

export default {
  components: {
    BuscarDocFiscal,
    EditarDocFiscal,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isLoadingFor: false,
      isFullscreen: false,
      fornecedorSelected: [],
      optionsFornecedor: [],
      optionsMunicipioIni: [],
      optionsMunicipioFim: [],
      optionsPortoOrigem: [],
      optionsPortoTransbordo: [],
      optionsPortoDestino: [],
      optionsEmbarcacao: [],
      optionsParamUnidadeMedida: [],
      optionsParamTipoMedida: [],
      optionsParamRespSeg: [],
      optionsSeguradora: [],
      optionsCustos: [],
      optionsLivTpValorCarga: [],
      optionsLivGlobalizado: [],
      optionsLivDocFiscalTpDoc: [],
      optionsLivDocTranspTpDoc: [],
      optionsLivTpPessoa: [],
      optionsMunicipios: [],
      optionsParamMotivo: [],
      optionsExpedidor: [],
      optionsRecebedor: [],
      optionsTomador: [],
      optionsLivCfop: [],
      optionsLivTpServico: [],
      optionsModelo: [],
      optionsParamCst: [],
      isLoadingExp: false,
      isLoadingRec: false,
      isLoadingTom: false,
      isLoadingEnderecoEmi: false,
      showPopoverChaveNFe: false,
      showPopover: false,
      loadingCep: false,
      loadingCepEmi: false,
      loadingCepDes: false,
      loadingAddDoc: false,
      cstSelected: [],
      cfopSelected: [],
      tpServicoSelected: [],
      municipioIniSelected: [],
      municipioFimSelected: [],
      portoOrigemSelected: [],
      portoTransbordoSelected: [],
      portoDestinoSelected: [],
      embarcacaoSelected: [],
      expedidorSelected: [],
      recebedorSelected: [],
      tomadorOutrosSelected: [],
      vn_vlr_cte: 0,
      mascaraEmiNfe: "###.###.###-##",
      mascaraDesNfe: "###.###.###-##",
      mascaraDesCte: "###.###.###-##",
      vn_aliquota: 0,
      vn_percentual_reducao_bc: 0,
      activateDesativate: [],
      obs_cont: [],
      obs_fisco: [],
      docfis: [],
      docfisDig: [],
      doctransp: [],
      doctranspDig: [],
      errors_array: [],
      carga_medida: [{ parunidmed_id: "", partpmed_id: "", qtde_carga: 0 }],

      seguro: [{ partprese_id: "", segurado_id: "" }],

      comp_frete: [{ custo_id: "", vlr: 0 }],
      help_form: new Form({
        ocultarRecord: [],
        globalizado: 2,
      }),
      form: new Form({
        parcst_id: "",
        chave_cte_multi: "",
        chave: "",
        tp_orig_doc: 1,
        cfop_id: "",
        rntrc: "",
        cd_cst: "",
        cotm: "",
        tp_servico: "",
        tp_cte: 0,
        municipio_id_ini: "",
        municipio_id_fim: "",
        docs: [],
        produto_predominante: "",
        vlr_cte: 0,
        vlr_carga_averbacao: 0,
        vlr_aliquota: 0,
        vlr_imposto: 0,
        vlr_total: 0,
        percentual_reducao_bc: 0,
        docfis: [],
        doctransp: [],
        porto_id_transb: "",
        porto_id_des: "",
        embarcacao_id: "",
        num_viagem: "",
        pessoa_id_rec: "",
        pessoa_id_exp: "",
        tomador: "",
        globalizado: 2,
        pessoa_id_tom: "",
        obs: "",
        tp_operacao: 1,
        tp_processo: 1,
        tp_valor_carga: 1,
        vlr_aliquota_afrmm: 0,
        modal: "",
        carga_medida: [],
        seguro: [],
        obs_cont: [],
        obs_fisco: [],
        comp_frete: [],
        modelo_cte: [],
        doctranspDig: [],
        docfisDig: [],
        doc_id: "",
        doccte_id: "",
      }),
      form_doctransp: new Form({
        doctransp: [],
        chave: "",
        emi_cnpj_cpf_cuit: "",
        emi_ie: "",
        emi_nome: "",
        emi_cep: "",
        emi_numero: "",
        emi_bairro: "",
        emi_endereco: "",
        emi_municipio: [],
        emi_complemento: "",
        des_tp_pessoa: "",
        des_cnpj_cpf_cuit: "",
        des_ie: "",
        des_nome: "",
        des_cep: "",
        des_numero: "",
        des_bairro: "",
        des_endereco: "",
        des_municipio: [],
        des_complemento: "",
        des_pin: "",
        tp_doc: [],
        num_fiscal: "",
        serie: "",
        dt_emissao: "",
        qtd_volume: "",
        peso_bruto: 0,
        vlr_total_cte: 0,
        cep_busca: "",
      }),
      helpForm: new Form({
        statusRecord: [],
        bcliente_id_active: "",
        params: [],
        search: "",
        docs: [],
        chave: "",
        emi_tp_pessoa: 1,
        emi_cnpj_cpf_cuit: "",
        emi_ie: "",
        emi_nome: "",
        emi_cep: "",
        emi_numero: "",
        emi_bairro: "",
        emi_endereco: "",
        emi_municipio: [],
        emi_complemento: "",
        des_tp_pessoa: 1,
        des_cnpj_cpf_cuit: "",
        des_ie: "",
        des_nome: "",
        des_cep: "",
        des_numero: "",
        des_bairro: "",
        des_endereco: "",
        des_municipio: [],
        des_complemento: "",
        des_pin: "",
        tp_doc: [],
        num_fiscal: "",
        serie: "",
        dt_emissao: "",
        qtd_volume: "",
        peso_bruto: 0,
        vlr_total_nfe: 0,
        cep_busca: "",
        globalizado: 2,
      }),
      fields: [],
      css: {
        tableClass: "table",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
        detailRowClass: "vuetable-detail-row",
      },
      moreParams: {},
    };
  },
  watch: {
    cstSelected(obj) {
      this.form.parcst_id = obj.value;
      this.form.cd_cst = obj.cd;
    },
    cfopSelected(obj) {
      this.form.cfop_id = obj.value;
    },
    tpServicoSelected(obj) {
      this.form.tp_servico = obj.value;
    },
    municipioIniSelected(obj) {
      this.form.municipio_id_ini = obj.value;
    },
    municipioFimSelected(obj) {
      this.form.municipio_id_fim = obj.value;
    },
    portoOrigemSelected(obj) {
      this.form.porto_id_emb = obj.value;
    },
    portoTransbordoSelected(obj) {
      this.form.porto_id_transb = obj.value;
    },
    portoDestinoSelected(obj) {
      this.form.porto_id_des = obj.value;
    },
    expedidorSelected(obj) {
      this.form.pessoa_id_exp = obj.value;
    },
    recebedorSelected(obj) {
      this.form.pessoa_id_rec = obj.value;
    },
    tomadorOutrosSelected(obj) {
      this.form.pessoa_id_tom = obj.value;
    },
    embarcacaoSelected(obj) {
      this.form.embarcacao_id = obj.value;
    },
  },
  mounted() {
    this.getLivGeral();
  },
  methods: {
    onBuscarDoc(data) {
      this.$refs.buscardocfiscal.onBuscarDocFiscal(data); // PedidoUnidadeCarga
    },
    onEditDoc(data, index) {
      this.$refs.editardocfiscal.onCreate(data); // PedidoUnidadeCarga
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate();
      }
    },
    onCreate() {
      this.loading = true;
      this.isDisabled = true;
      this.errors_array = "";
      this.errors_array = [];
      this.helpForm.bcliente_id_active = this.user.bcliente_id_active;
      this.helpForm
        .post("/api/cte/getcte")
        .then((response) => {
          if (response.periodo) {
            var obj = {
              isShown: true,
              title: "Erro",
              message:
                "Seu periodo expirou. Caso queria fazer um upgrade de versão" +
                "<a target='_blank' href='/dashboard#/conta'> clique aqui</a>",
              type: "error",
              customCloseBtnText: "Fechar",
              useConfirmBtn: false,
            };
            this.$Simplert.open(obj);
          } else {
            if (response.cte < this.b_plano.qtde_cte) {
              this.modal_titulo = "Gerar CTE";
              this.modal_botao = "Gerar CTE";
              this.modal_acao = "i";
              this.loading = false;
              this.isDisabled = false;
              this.form.reset();
              this.docfis = null;
              this.docfis = [];
              this.carga_medida = null;
              this.carga_medida = [];
              this.carga_medida.push({
                qtde_carga: "",
                medida: [],
                tipomedida: [],
              });
              this.comp_frete = null;
              this.comp_frete = [];
              this.comp_frete.push({ custo_id: "", vlr: 0 });
              this.seguro = null;
              this.seguro = [];
              this.form.globalizado = { label: "Não", value: 2 };
              this.$refs.gerarctemodalform.onCreate(this.optionsModelo);
            } else {
              var obj = {
                isShown: true,
                title: "Erro",
                message:
                  "Você atingiu o limite de CTes ativas cadastradas para o seu plano " +
                  response.cte +
                  "/" +
                  this.b_plano.qtde_cte +
                  ". Caso queria fazer um upgrade de versão" +
                  "<a target='_blank' href='/dashboard#/conta'> clique aqui</a>",
                type: "error",
                customCloseBtnText: "Fechar",
                useConfirmBtn: false,
              };
              this.$Simplert.open(obj);
            }
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.tp_orig_doc = 1; // Gerar CTE
      this.form.carga_medida = this.carga_medida;
      this.form.seguro = this.seguro;
      this.form.obs_cont = this.obs_cont;
      this.form.obs_fisco = this.obs_fisco;
      this.form.comp_frete = this.comp_frete;
      this.form.docfis = this.docfis;
      this.form.docfisDig = this.docfisDig;
      this.form.doctransp = this.doctransp;
      this.form.doctranspDig = this.doctranspDig;

      this.form.carga_medida.forEach((item, index) => {
        if (item.parunidmed_id !== "" && item.partpmed_id !== "") {
          this.form.carga_medida[index].parunidmed_id =
            item.parunidmed_id.value;
          this.form.carga_medida[index].partpmed_id = item.partpmed_id.value;
        }
      });
      this.form.comp_frete.forEach((item, index) => {
        if (item.custo_id !== "") {
          this.form.comp_frete[index].custo_id = item.custo_id.value;
        }
      });
      this.form.seguro.forEach((item, index) => {
        if (item.segurado_id !== "" && item.partprese_id !== "") {
          this.form.seguro[index].segurado_id = item.segurado_id.value;
          this.form.seguro[index].partprese_id = item.partprese_id.value;
        }
      });
      this.form
        .post("api/gerardoc/store")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          } else {
            this.$parent.$parent.onFilterReset();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({ erro: obj });
                });
              }
            }
          }
        });
    },
    onUpdate() {
      this.loading = true;
      this.isDisabled = true;
      this.form.tp_orig_doc = 1; // Gerar CTE
      this.form.carga_medida = this.carga_medida;
      this.form.seguro = this.seguro;
      this.form.obs_cont = this.obs_cont;
      this.form.obs_fisco = this.obs_fisco;
      this.form.comp_frete = this.comp_frete;
      this.form.docfis = this.docfis;
      this.form.docfisDig = this.docfisDig;
      this.form.doctransp = this.doctransp;
      this.form.doctranspDig = this.doctranspDig;

      this.form.carga_medida.forEach((item, index) => {
        if (item.parunidmed_id !== "" && item.partpmed_id !== "") {
          this.form.carga_medida[index].parunidmed_id =
            item.parunidmed_id.value;
          this.form.carga_medida[index].partpmed_id = item.partpmed_id.value;
        }
      });
      this.form.comp_frete.forEach((item, index) => {
        if (item.custo_id !== "") {
          this.form.comp_frete[index].custo_id = item.custo_id.value;
        }
      });
      this.form.seguro.forEach((item, index) => {
        if (item.segurado_id !== "" && item.partprese_id !== "") {
          this.form.seguro[index].segurado_id = item.segurado_id.value;
          this.form.seguro[index].partprese_id = item.partprese_id.value;
        }
      });
      this.form
        .patch("/api/cte/update")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          } else {
            this.$parent.$parent.onFilterReset();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({ erro: obj });
                });
              }
            }
          }
        });
    },
    onGerarCte(e, modal) {
      e.preventDefault();
      this.modal_titulo = "Gerar CTE";
      this.modal_botao = "Gerar CTE";
      this.modal_acao = "i";
      this.loading = false;
      this.isDisabled = false;
      this.form.reset();
      this.obs_cont = null;
      this.obs_fisco = null;
      this.docfisDig = null;
      this.doctransp = null;
      this.doctranspDig = null;
      this.obs_cont = [];
      this.obs_fisco = [];
      this.docfisDig = [];
      this.doctransp = [];
      this.doctranspDig = [];
      this.docfis = null;
      this.docfis = [];
      this.carga_medida = null;
      this.carga_medida = [];
      this.carga_medida.push({
        qtde_carga: 0,
        parunidmed_id: "",
        partpmed_id: "",
      });
      this.comp_frete = null;
      this.comp_frete = [];
      this.comp_frete.push({ custo_id: "", vlr: 0 });
      this.seguro = null;
      this.seguro = [];
      this.form.globalizado = 2; //Não
      this.form.tp_valor_carga = 1; //Vlr Total NFE
      this.cstSelected = [];
      this.cfopSelected = [];
      this.tpServicoSelected = [];
      this.municipioIniSelected = [];
      this.municipioFimSelected = [];
      this.portoOrigemSelected = [];
      this.portoTransbordoSelected = [];
      this.portoDestinoSelected = [];
      this.expedidorSelected = [];
      this.recebedorSelected = [];
      this.tomadorOutrosSelected = [];
      this.embarcacaoSelected = [];
      this.form.vlr_cte = parseFloat(0);
      this.form.vlr_carga_averbacao = parseFloat(0);
      this.form.vlr_aliquota = parseFloat(0);
      this.form.vlr_imposto = parseFloat(0);
      this.form.percentual_reducao_bc = parseFloat(0);
      this.form.vlr_total = parseFloat(0);
      this.form.vlr_aliquota_afrmm = parseFloat(0);
      this.form.modal = modal;
      // Caso tenha sido selecionado modelo
      if (this.$parent.form.modelo_cte !== "") {
        this.cstSelected = {
          label:
            this.$parent.form.modelo_cte.mod.param_cst.cd +
            " - " +
            this.$parent.form.modelo_cte.mod.param_cst.descr,
          cd: this.$parent.form.modelo_cte.mod.param_cst.cd,
          value: this.$parent.form.modelo_cte.mod.param_cst.parcst_id,
        };
        this.form.produto_predominante =
          this.$parent.form.modelo_cte.mod.produto_predominante;
        this.form.vlr_cte = parseFloat(
          this.$parent.form.modelo_cte.mod.vlr_cte
        );
        this.form.vlr_aliquota = parseFloat(
          this.$parent.form.modelo_cte.mod.aliquota_icms
        );
        this.form.vlr_imposto = parseFloat(
          this.$parent.form.modelo_cte.mod.vlr_imposto
        );
        this.form.percentual_reducao_bc = parseFloat(
          this.$parent.form.modelo_cte.mod.percentual_reducao_bc
        );
        this.tpServicoSelected = {
          label: this.$parent.form.modelo_cte.mod.tp_servico.descr,
          value: this.$parent.form.modelo_cte.mod.tp_servico.valor,
        };
        this.form.globalizado =
          this.$parent.form.modelo_cte.mod.globalizado.valor;
        this.form.tp_valor_carga =
          this.$parent.form.modelo_cte.mod.tp_valor_carga.valor;
        this.form.obs = this.$parent.form.modelo_cte.mod.obs;
        this.form.tomador = this.$parent.form.modelo_cte.mod.tomador;
        this.cfopSelected = {
          label:
            this.$parent.form.modelo_cte.mod.cfop.cd +
            " - " +
            this.$parent.form.modelo_cte.mod.cfop.descr,
          value: this.$parent.form.modelo_cte.mod.cfop.cfop_id,
          cd: this.$parent.form.modelo_cte.mod.cfop.cd,
        };
        this.municipioIniSelected = {
          label:
            this.$parent.form.modelo_cte.mod.municipio_inicio.nome +
            " - " +
            this.$parent.form.modelo_cte.mod.municipio_inicio.cd_ibge,
          value: this.$parent.form.modelo_cte.mod.municipio_inicio.municipio_id,
        };
        this.municipioFimSelected = {
          label:
            this.$parent.form.modelo_cte.mod.municipio_fim.nome +
            " - " +
            this.$parent.form.modelo_cte.mod.municipio_fim.cd_ibge,
          value: this.$parent.form.modelo_cte.mod.municipio_fim.municipio_id,
        };

        this.carga_medida = null;
        this.carga_medida = [];
        this.$parent.form.modelo_cte.mod.modelo_cte_carga.forEach((obj) => {
          this.carga_medida.push({
            qtde_carga: parseFloat(obj.qtd),
            parunidmed_id: {
              label: obj.param_unidade_medida.descr,
              value: obj.param_unidade_medida.parunidmed_id,
            },
            partpmed_id: {
              label: obj.param_tipo_medida.descr,
              value: obj.param_tipo_medida.partpmed_id,
            },
          });
        });

        this.comp_frete = null;
        this.comp_frete = [];
        this.$parent.form.modelo_cte.mod.modelo_cte_comp_frete.forEach(
          (obj) => {
            this.comp_frete.push({
              custo_id: {
                label: obj.custo.descr + " - " + obj.custo.cd,
                value: obj.custo.custo_id,
              },
              vlr: parseFloat(obj.vlr),
            });
          }
        );

        this.seguro = null;
        this.seguro = [];
        this.$parent.form.modelo_cte.mod.modelo_cte_seguro.forEach((obj) => {
          this.seguro.push({
            partprese_id: {
              label: obj.param_tipo_resp_seg.descr,
              value: obj.param_tipo_resp_seg.cd,
            },
            segurado_id: {
              label: obj.seguradora.descr,
              value: obj.seguradora.cd,
            },
            nome: obj.seguradora.nome,
            partprese_id: obj.param_tipo_resp_seg.partprese_id,
          });
        });

        // Calcula o valor do CTe
        this.calcCte();
      }
      this.$parent.$parent.$refs.vuetable.selectedTo.forEach((docfis_id) => {
        this.$parent.$parent.$refs.vuetable.tableData.forEach((obj) => {
          if (obj.docfis_id == docfis_id) {
            this.docfis.push({
              id: obj.docfis_id,
              chave: obj.chave,
              num_fiscal: obj.num_fiscal,
              serie: obj.serie,
              dt_emissao: obj.dt_emissao,
              emi_nome: obj.doc_fiscal_partes_env.emi_nome,
              emi_cnpj: obj.doc_fiscal_partes_env.emi_cnpj,
              des_nome: obj.doc_fiscal_partes_env.des_nome,
              des_cnpj: obj.doc_fiscal_partes_env.des_cnpj,
              tp_doc_valor: obj.liv_tp_doc.valor,
              tp_doc_descr: obj.liv_tp_doc.descr,
              tp_doc: obj.liv_tp_doc,
            });
          }
        });
      });
      this.$parent.$refs.modal_form.hide();
      this.$refs.modal_form.show();
    },
    onEdit(data) {
      console.log(data);
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar CTE " + data.b_modal.descr;
      this.modal_botao = "Alterar CTE " + data.b_modal.descr;
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.docfis = null;
      this.docfis = [];
      this.carga_medida = null;
      this.carga_medida = [];
      this.comp_frete = null;
      this.comp_frete = [];
      this.seguro = null;
      this.seguro = [];
      this.cstSelected = [];
      this.cfopSelected = [];
      this.tpServicoSelected = [];
      this.municipioIniSelected = [];
      this.municipioFimSelected = [];
      this.portoOrigemSelected = [];
      this.portoTransbordoSelected = [];
      this.portoDestinoSelected = [];
      this.expedidorSelected = [];
      this.recebedorSelected = [];
      this.tomadorOutrosSelected = [];
      this.embarcacaoSelected = [];
      this.form.vlr_cte = parseFloat(0);
      this.form.vlr_carga_averbacao = parseFloat(0);
      this.form.vlr_aliquota = parseFloat(0);
      this.form.vlr_imposto = parseFloat(0);
      this.form.percentual_reducao_bc = parseFloat(0);
      this.form.vlr_total = parseFloat(0);
      this.form.vlr_aliquota_afrmm = parseFloat(0);
      this.form.tp_orig_doc = 1;
      this.form.modal = data.b_modal.cd;
      this.form.globalizado = data.doc_cte.globalizado;
      this.form.tp_operacao = data.tp_operacao;
      this.form.tp_processo = data.tp_processo;
      this.form.tp_valor_carga = 1; //Vlr Total NFE
      if (data.doc_cte.doc_cte_imposto.param_cst.parcst_id !== null) {
        this.cstSelected = {
          label:
            data.doc_cte.doc_cte_imposto.param_cst.cd +
            " - " +
            data.doc_cte.doc_cte_imposto.param_cst.descr,
          cd: data.doc_cte.doc_cte_imposto.param_cst.cd,
          value: data.doc_cte.doc_cte_imposto.param_cst.parcst_id,
        };
      }
      if (data.doc_cte.cfop.cfop_id !== null) {
        this.cfopSelected = {
          label: data.doc_cte.cfop.cd + " - " + data.doc_cte.cfop.descr,
          value: data.doc_cte.cfop.cfop_id,
          cd: data.doc_cte.cfop.cd,
        };
      }
      if (data.doc_cte.doc_cte_vin_multimodal.length > 0) {
        this.form.chave_cte_multi =
          data.doc_cte.doc_cte_vin_multimodal[0].chave;
      }
      this.tpServicoSelected = {
        label: data.doc_cte.tp_servico.descr,
        value: data.doc_cte.tp_servico.valor,
      };
      this.municipioIniSelected = {
        label:
          data.municipio_inicio.nome + " - " + data.municipio_inicio.cd_ibge,
        value: data.municipio_inicio.municipio_id,
      };
      this.municipioFimSelected = {
        label: data.municipio_fim.nome + " - " + data.municipio_fim.cd_ibge,
        value: data.municipio_fim.municipio_id,
      };
      this.form.produto_predominante =
        data.doc_cte.doc_cte_adicional.produto_predominante;
      this.form.vlr_cte = parseFloat(
        data.doc_cte.doc_cte_imposto.vlr_base_calculo -
          data.doc_cte.doc_cte_imposto.vlr_icms
      );
      this.form.vlr_imposto = parseFloat(data.doc_cte.doc_cte_imposto.vlr_icms);
      this.form.vlr_aliquota = parseFloat(
        data.doc_cte.doc_cte_imposto.aliquota_icms
      );
      this.form.percentual_reducao_bc = parseFloat(
        data.doc_cte.doc_cte_imposto.percentual_reducao_bc
      );
      this.form.obs = data.doc_cte.doc_cte_adicional.observacao_geral;
      this.form.vlr_total = parseFloat(
        data.doc_cte.doc_cte_imposto.vlr_base_calculo
      );
      this.form.tomador = data.tomador;

      this.seguro = null;
      this.seguro = [];
      data.doc_cte.doc_cte_seguro.forEach((obj) => {
        this.seguro.push({
          partprese_id: {
            label: obj.param_tipo_resp_seg.descr,
            value: obj.param_tipo_resp_seg.cd,
          },
          segurado_id: {
            label: obj.seguradora.descr,
            value: obj.seguradora.cd,
          },
          nome: obj.seguradora.nome,
          partprese_id: obj.param_tipo_resp_seg.partprese_id,
        });
      });
      this.obs_cont = null;
      this.obs_cont = [];
      if (data.doc_cte.doc_cte_adicional.doc_cte_adicional_obs.length > 0) {
        data.doc_cte.doc_cte_adicional.doc_cte_adicional_obs.forEach((obj) => {
          this.obs_cont.push({
            xcampo: obj.campo,
            xtexto: obj.texto,
          });
        });
      }
      this.obs_fisco = null;
      this.obs_fisco = [];
      if (data.doc_cte.doc_cte_adicional.doc_cte_adicional_fluxo.length > 0) {
        data.doc_cte.doc_cte_adicional.doc_cte_adicional_fluxo.forEach(
          (obj) => {
            this.obs_fisco.push({ xcampo: obj.campo, xtexto: obj.texto });
          }
        );
      }

      if (data.doc_cte_partes_env.pessoa_exp !== null) {
        this.expedidorSelected = {
          label:
            data.doc_cte_partes_env.pessoa_exp.pessoa_juridica
              .exp_nome_fantasia +
            " - " +
            this.onFormataCnpj(
              data.doc_cte_partes_env.pessoa_exp.pessoa_juridica.cnpj_base,
              data.doc_cte_partes_env.pessoa_exp.pessoa_juridica.cnpj_filial,
              data.doc_cte_partes_env.pessoa_exp.pessoa_juridica.cnpj_digito
            ) +
            " - " +
            data.doc_cte_partes_env.pessoa_exp.pessoa_juridica
              .inscricao_estadual,
          value: data.doc_cte_partes_env.pessoa_exp.pessoa_juridica.pessoa_id,
        };
      }

      if (data.doc_cte_partes_env.pessoa_rec !== null) {
        this.recebedorSelected = {
          label:
            data.doc_cte_partes_env.rec_nome_fantasia +
            " - " +
            this.onFormataCnpj(
              data.doc_cte_partes_env.pessoa_rec.pessoa_juridica.cnpj_base,
              data.doc_cte_partes_env.pessoa_rec.pessoa_juridica.cnpj_filial,
              data.doc_cte_partes_env.pessoa_rec.pessoa_juridica.cnpj_digito
            ) +
            " - " +
            data.doc_cte_partes_env.pessoa_rec.pessoa_juridica
              .inscricao_estadual,
          value: data.doc_cte_partes_env.pessoa_rec.pessoa_juridica.pessoa_id,
        };
      }

      if (data.doc_cte_partes_env.pessoa_rem !== null && data.tomador == 4) {
        this.tomadorOutrosSelected = {
          label:
            data.doc_cte_partes_env.pessoa_rem.pessoa_juridica.nome_fantasia +
            " - " +
            this.onFormataCnpj(
              data.doc_cte_partes_env.pessoa_rem.pessoa_juridica.cnpj_base,
              data.doc_cte_partes_env.pessoa_rem.pessoa_juridica.cnpj_filial,
              data.doc_cte_partes_env.pessoa_rem.pessoa_juridica.cnpj_digito
            ) +
            " - " +
            data.doc_cte_partes_env.pessoa_rem.pessoa_juridica
              .inscricao_estadual,
          value: data.doc_cte_partes_env.pessoa_rem.pessoa_juridica.pessoa_id,
        };
      }

      data.doc_cte.doc_cte_carga.forEach((obj) => {
        this.carga_medida.push({
          qtde_carga: parseFloat(obj.qtd),
          parunidmed_id: {
            label: obj.param_unidade_medida.descr,
            value: obj.param_unidade_medida.parunidmed_id,
          },
          partpmed_id: {
            label: obj.param_tipo_medida.descr,
            value: obj.param_tipo_medida.partpmed_id,
          },
        });
      });

      data.doc_cte.doc_cte_comp_frete.forEach((obj) => {
        this.comp_frete.push({
          custo_id: {
            label: obj.custo.descr + " - " + obj.custo.cd,
            value: obj.custo.custo_id,
          },
          vlr: parseFloat(obj.vlr),
        });
      });

      if (data.doc_cte.doc_cte_rodo != undefined) {
        this.form.rntrc = data.doc_cte.doc_cte_rodo.rntrc;
      }

      data.doc_cte.doc_carga_doc.forEach((obj) => {
        if (obj.carga_doc.doc_fiscal !== null) {
          this.docfis.push({
            id: obj.carga_doc.doc_fiscal.docfis_id,
            chave: obj.carga_doc.doc_fiscal.chave,
            num_fiscal: obj.carga_doc.doc_fiscal.num_fiscal,
            serie: obj.carga_doc.doc_fiscal.serie,
            dt_emissao: obj.carga_doc.doc_fiscal.dt_emissao,
            emi_nome: obj.carga_doc.doc_fiscal.doc_fiscal_partes_env.emi_nome,
            emi_cnpj: obj.carga_doc.doc_fiscal.doc_fiscal_partes_env.emi_cnpj,
            des_nome: obj.carga_doc.doc_fiscal.doc_fiscal_partes_env.des_nome,
            des_cnpj: obj.carga_doc.doc_fiscal.doc_fiscal_partes_env.des_cnpj,
            tp_doc: obj.carga_doc.doc_fiscal.liv_tp_doc,
          });
        } else if (obj.carga_doc.doc_transp !== null) {
          this.doctransp.push({
            id: obj.carga_doc.doc_transp.doctransp_id,
            chave: obj.carga_doc.doc_transp.chave,
            num_fiscal: obj.carga_doc.doc_transp.num_doc,
            serie: obj.carga_doc.doc_transp.serie,
            dt_emissao: obj.carga_doc.doc_transp.dt_emissao,
            emi_nome: obj.carga_doc.doc_transp.doc_transp_partes_env.emi_nome,
            emi_cnpj: obj.carga_doc.doc_transp.doc_transp_partes_env.emi_cnpj,
            des_nome: obj.carga_doc.doc_transp.doc_transp_partes_env.des_nome,
            des_cnpj: obj.carga_doc.doc_transp.doc_transp_partes_env.des_cnpj,
            tp_doc: obj.carga_doc.doc_transp.liv_tp_doc,
          });
        }
      });
      this.form.doc_id = data.doc_id;
      this.form.doccte_id = data.doc_cte.doccte_id;
      this.$refs.modal_form.show();
    },
    calcCte() {
      this.vn_vlr_cte = this.form.vlr_cte;
      this.vn_aliquota = this.form.vlr_aliquota;
      this.form.vlr_imposto = Number(
        this.vn_vlr_cte / ((100 - this.vn_aliquota) / 100) - this.vn_vlr_cte
      );
      this.vn_vlr_total = this.vn_vlr_cte + this.form.vlr_imposto;
      this.form.vlr_total = Number(this.vn_vlr_total);
    },
    listaClientesExpedidor(search) {
      if (search.length >= 3) {
        this.isLoadingExp = true;
        this.helpForm.search = search;
        this.helpForm
          .post("/api/pessoa/jsonlist")
          .then((response) => {
            this.optionsExpedidor = [];
            new ReturnApi(response, this, true, false, false);
            response.items.forEach((obj) => {
              this.optionsExpedidor.push({
                label:
                  obj.pessoa.cd +
                  " - " +
                  obj.razao_social +
                  " - " +
                  this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ) +
                  " - " +
                  obj.inscricao_estadual,
                value: obj.pessoa_id,
              });
            });
            this.isLoadingExp = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    listaClientesRecebedor(search) {
      if (search.length >= 3) {
        this.isLoadingRec = true;
        this.helpForm.search = search;
        this.helpForm
          .post("/api/pessoa/jsonlist")
          .then((response) => {
            this.optionsRecebedor = [];
            new ReturnApi(response, this, true, false, false);
            response.items.forEach((obj) => {
              this.optionsRecebedor.push({
                label:
                  obj.pessoa.cd +
                  " - " +
                  obj.razao_social +
                  " - " +
                  this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ) +
                  " - " +
                  obj.inscricao_estadual,
                value: obj.pessoa_id,
              });
            });
            this.isLoadingRec = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    listaClientesTomador(search) {
      if (search.length >= 3) {
        this.isLoadingTom = true;
        this.helpForm.search = search;
        this.helpForm
          .post("/api/pessoa/jsonlist")
          .then((response) => {
            this.optionsTomador = [];
            new ReturnApi(response, this, true, false, false);
            response.items.forEach((obj) => {
              this.optionsTomador.push({
                label:
                  obj.pessoa.cd +
                  " - " +
                  obj.razao_social +
                  " - " +
                  this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ) +
                  " - " +
                  obj.inscricao_estadual,
                value: obj.pessoa_id,
              });
            });
            this.isLoadingTom = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    getLivGeral() {
      this.helpForm
        .get("/api/gerardoc/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.param_cst.forEach((obj) => {
            this.optionsParamCst.push({
              label: obj.cd + " - " + obj.descr,
              value: obj.parcst_id,
              cd: obj.cd,
            });
          });

          response.cfops.forEach((obj) => {
            this.optionsLivCfop.push({
              label: obj.cd + " - " + obj.descr,
              value: obj.cfop_id,
            });
          });

          response.tp_servico.forEach((obj) => {
            this.optionsLivTpServico.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.municipios.forEach((obj) => {
            this.optionsMunicipioIni.push({
              label: obj.nome + " - " + obj.cd_ibge,
              value: obj.municipio_id,
            });
            this.optionsMunicipioFim.push({
              label: obj.nome + " - " + obj.cd_ibge,
              value: obj.municipio_id,
            });
            this.optionsMunicipios.push({
              label: obj.nome,
              ibge: obj.cd_ibge,
              value: obj.municipio_id,
            });
          });
          response.portos.forEach((obj) => {
            this.optionsPortoOrigem.push({
              label: obj.nome + " - " + obj.cd,
              value: obj.porto_id,
            });
            this.optionsPortoTransbordo.push({
              label: obj.nome + " - " + obj.cd,
              value: obj.porto_id,
            });
            this.optionsPortoDestino.push({
              label: obj.nome + " - " + obj.cd,
              value: obj.porto_id,
            });
          });
          response.embarcacao.forEach((obj) => {
            this.optionsEmbarcacao.push({
              label: obj.nome + " - " + obj.irin,
              value: obj.embarcacao_id,
            });
          });
          response.tp_valor_carga.forEach((obj) => {
            this.optionsLivTpValorCarga.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.globalizado.forEach((obj) => {
            this.optionsLivGlobalizado.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.medida.forEach((obj) => {
            this.optionsParamUnidadeMedida.push({
              label: obj.descr + " - " + obj.cd,
              value: obj.parunidmed_id,
            });
          });
          response.tipomedida.forEach((obj) => {
            this.optionsParamTipoMedida.push({
              label: obj.descr + " - " + obj.cd,
              value: obj.partpmed_id,
            });
          });
          response.respseg.forEach((obj) => {
            this.optionsParamRespSeg.push({
              label: obj.descr + " - " + obj.cd,
              value: obj.partprese_id,
            });
          });
          response.seguradora.forEach((obj) => {
            this.optionsSeguradora.push({
              label: obj.nome + " - " + obj.apolice,
              value: obj.segurado_id,
            });
          });
          response.custos.forEach((obj) => {
            this.optionsCustos.push({
              label: obj.descr + " - " + obj.cd,
              value: obj.custo_id,
            });
          });

          response.doc_fiscal_tp_doc.forEach((obj) => {
            this.optionsLivDocFiscalTpDoc.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.doc_transp_tp_doc.forEach((obj) => {
            this.optionsLivDocTranspTpDoc.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.tp_pessoa.forEach((obj) => {
            this.optionsLivTpPessoa.push({ text: obj.descr, value: obj.valor });
          });

          response.modelo_cte.forEach((obj) => {
            this.optionsModelo.push({
              label: obj.descr + " - " + obj.cd,
              value: obj.modcte_id,
              mod: obj,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onBuscarDocAssociar(data) {
      var c = true;
      data.forEach((obj) => {
        c = true;
        this.docfis.forEach((obj2) => {
          if (obj2.id == obj.id) {
            c = false;
          }
        });

        if (c) {
          this.docfis.push({
            id: obj.id,
            chave: obj.chave,
            num_fiscal: obj.num_fiscal,
            serie: obj.serie,
            dt_emissao: obj.dt_emissao,
            emi_nome: obj.emi_nome,
            emi_cnpj: obj.emi_cnpj,
            des_nome: obj.des_nome,
            des_cnpj: obj.des_cnpj,
            tp_doc: obj.tp_doc,
          });
        }
      });
      this.$refs.modal_form.show();
    },
    onVoltar() {
      this.$refs.modal_form.show();
    },
    addDoc() {
      this.loadingAddDoc = true;
      this.isDisabledAddDoc = true;
      this.helpForm.docs = this.docfis;
      this.helpForm.globalizado = this.form.globalizado.value;
      //this.helpForm.dt_emissao = this.formatDateSubmit(this.helpForm.dt_emissao);
      this.helpForm
        .post("/api/associar/adddoc")
        .then((response) => {
          this.docfis.push({
            id: response.docfis_id,
            chave: response.chave,
            num_fiscal: response.num_fiscal,
            serie: response.serie,
            dt_emissao: response.dt_emissao,
            emi_nome: response.doc_fiscal_partes_env.emi_nome,
            emi_cnpj: response.doc_fiscal_partes_env.emi_cnpj,
            des_nome: response.doc_fiscal_partes_env.des_nome,
            des_cnpj: response.doc_fiscal_partes_env.des_cnpj,
            tp_doc_valor: response.liv_tp_doc.valor,
            tp_doc_descr: response.liv_tp_doc.label,
            tp_doc: response.liv_tp_doc,
          });
          this.loadingAddDoc = false;
          this.isDisabledAddDoc = false;
          this.helpForm.chave = "";
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          this.loadingAddDoc = false;
          this.isDisabledAddDoc = false;
          new ReturnApi(errors, this);
        });
    },
    addDocDigitacao() {
      this.loadingAddDoc = true;
      this.isDisabledAddDoc = true;
      this.helpForm.docs = this.docfis;
      //Replaces
      this.helpForm.emi_cnpj_cpf_cuit = this.helpForm.emi_cnpj_cpf_cuit.replace(
        /([-./])/g,
        ""
      );
      this.helpForm.des_cnpj_cpf_cuit = this.helpForm.des_cnpj_cpf_cuit.replace(
        /([-./])/g,
        ""
      );
      this.helpForm.emi_cep = this.helpForm.emi_cep.replace("-", "");
      this.helpForm.des_cep = this.helpForm.des_cep.replace("-", "");
      // Ajustar para adicionar CTE's globalizados #REVISAR#
      // Chamada backend para validar
      //this.helpForm.dt_emissao = this.formatDateSubmit(this.helpForm.dt_emissao);
      this.helpForm
        .post("/api/associar/adddocdigitacao")
        .then((response) => {
          this.docfisDig.push({
            emi_tp_pessoa: this.helpForm.emi_tp_pessoa,
            emi_cnpj_cpf_cuit: this.helpForm.emi_cnpj_cpf_cuit,
            emi_ie: this.helpForm.emi_ie,
            emi_nome: this.helpForm.emi_nome,
            emi_cep: this.helpForm.emi_cep,
            emi_numero: this.helpForm.emi_numero,
            emi_bairro: this.helpForm.emi_bairro,
            emi_endereco: this.helpForm.emi_endereco,
            emi_municipio: this.helpForm.emi_municipio,
            emi_complemento: this.helpForm.emi_complemento,
            des_tp_pessoa: this.helpForm.des_tp_pessoa,
            des_cnpj_cpf_cuit: this.helpForm.des_cnpj_cpf_cuit,
            des_ie: this.helpForm.des_ie,
            des_nome: this.helpForm.des_nome,
            des_cep: this.helpForm.des_cep,
            des_numero: this.helpForm.des_numero,
            des_bairro: this.helpForm.des_bairro,
            des_endereco: this.helpForm.des_endereco,
            des_municipio: this.helpForm.des_municipio,
            des_complemento: this.helpForm.des_complemento,
            tp_doc_valor: this.helpForm.tp_doc.valor,
            tp_doc_descr: this.helpForm.tp_doc.label,
            tp_doc: this.helpForm.tp_doc,
            chave: this.helpForm.chave,
            num_fiscal: this.helpForm.num_fiscal,
            serie: this.helpForm.serie,
            dt_emissao: this.helpForm.dt_emissao,
            qtd_volume: this.helpForm.qtd_volume,
            peso_bruto: this.helpForm.peso_bruto,
            vlr_total_nfe: this.helpForm.vlr_total_nfe,
          });
          this.loadingAddDoc = false;
          this.$snotify.success(response.message);
          this.helpForm.reset();
          this.isDisabledAddDoc = false;
        })

        .catch((errors) => {
          this.loadingAddDoc = false;
          this.isDisabledAddDoc = false;
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({ erro: obj });
                });
              }
            }
          }
          new ReturnApi(errors, this);
        });
    },
    addDocTransp() {
      this.loading = true;
      this.isDisabled = true;
      this.form_doctransp.doctransp = this.doctransp;
      //this.form_doctransp.dt_emissao = this.formatDateSubmit(this.form_doctransp.dt_emissao);
      this.form_doctransp
        .post("/api/gerardoc/adddoctransp")
        .then((response) => {
          this.doctransp.push({
            id: response.doctransp_id,
            chave: response.chave,
            num_fiscal: response.num_doc,
            serie: response.serie,
            dt_emissao: response.dt_emissao,
            emi_nome: response.doc_transp_partes_env.emi_nome,
            emi_cnpj: response.doc_transp_partes_env.emi_cnpj,
            des_nome: response.doc_transp_partes_env.des_nome,
            des_cnpj: response.doc_transp_partes_env.des_cnpj,
            tp_doc_valor: response.liv_tp_doc.valor,
            tp_doc_descr: response.liv_tp_doc.label,
            tp_doc: response.liv_tp_doc,
          });
          this.form_doctransp.chave = "";
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    addDocTranspDigitacao() {
      this.loadingAddDoc = true;
      this.isDisabledAddDoc = true;
      this.form_doctransp.doctransp = this.doctranspDig;
      //Replaces
      this.form_doctransp.emi_cnpj_cpf_cuit =
        this.form_doctransp.emi_cnpj_cpf_cuit.replace(/([-./])/g, "");
      this.form_doctransp.des_cnpj_cpf_cuit =
        this.form_doctransp.des_cnpj_cpf_cuit.replace(/([-./])/g, "");
      this.form_doctransp.emi_cep = this.form_doctransp.emi_cep.replace(
        "-",
        ""
      );
      this.form_doctransp.des_cep = this.form_doctransp.des_cep.replace(
        "-",
        ""
      );
      // Chamada backend para validar
      //this.form_doctransp.dt_emissao = this.formatDateSubmit(this.form_doctransp.dt_emissao);
      this.form_doctransp
        .post("/api/associar/adddoctranspdigitacao")
        .then((response) => {
          this.doctranspDig.push({
            emi_cnpj_cpf_cuit: this.form_doctransp.emi_cnpj_cpf_cuit,
            emi_ie: this.form_doctransp.emi_ie,
            emi_nome: this.form_doctransp.emi_nome,
            emi_cep: this.form_doctransp.emi_cep,
            emi_numero: this.form_doctransp.emi_numero,
            emi_bairro: this.form_doctransp.emi_bairro,
            emi_endereco: this.form_doctransp.emi_endereco,
            emi_municipio: this.form_doctransp.emi_municipio,
            emi_complemento: this.form_doctransp.emi_complemento,
            des_tp_pessoa: this.form_doctransp.des_tp_pessoa,
            des_cnpj_cpf_cuit: this.form_doctransp.des_cnpj_cpf_cuit,
            des_ie: this.form_doctransp.des_ie,
            des_nome: this.form_doctransp.des_nome,
            des_cep: this.form_doctransp.des_cep,
            des_numero: this.form_doctransp.des_numero,
            des_bairro: this.form_doctransp.des_bairro,
            des_endereco: this.form_doctransp.des_endereco,
            des_municipio: this.form_doctransp.des_municipio,
            des_complemento: this.form_doctransp.des_complemento,
            des_pin: this.form_doctransp.des_pin,
            tp_doc_valor: this.form_doctransp.tp_doc.valor,
            tp_doc_descr: this.form_doctransp.tp_doc.label,
            tp_doc: this.form_doctransp.tp_doc,
            chave: this.form_doctransp.chave,
            num_fiscal: this.form_doctransp.num_fiscal,
            serie: this.form_doctransp.serie,
            dt_emissao: this.form_doctransp.dt_emissao,
            qtd_volume: this.form_doctransp.qtd_volume,
            peso_bruto: this.form_doctransp.peso_bruto,
            vlr_total_cte: this.form_doctransp.vlr_total_cte,
          });

          this.loadingAddDoc = false;

          this.form_doctransp.chave = "";
          this.form_doctransp.reset();
          this.isDisabledAddDoc = false;
          vm.$snotify.success(response.message, response.title);
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          this.loadingAddDoc = false;
          this.isDisabledAddDoc = false;
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({ erro: obj });
                });
              }
            }
          }
          new ReturnApi(errors, this);
        });
    },
    getCep(en_tipo) {
      if (en_tipo == 1) {
        this.loadingCepEmi = true;
        this.helpForm.cep_busca = this.helpForm.emi_cep;
      } else if (en_tipo == 2) {
        this.loadingCepDes = true;
        this.helpForm.cep_busca = this.helpForm.des_cep;
      } else if (en_tipo == 3) {
        this.loadingCepEmi = true;
        this.helpForm.cep_busca = this.form_doctransp.emi_cep;
      } else if (en_tipo == 4) {
        this.loadingCepDes = true;
        this.helpForm.cep_busca = this.form_doctransp.des_cep;
      }
      //Nova variável "cep" somente com dígitos.
      var cep = this.helpForm.cep_busca.replace(/\D/g, "");

      //Verifica se campo cep possui valor informado.
      if (cep != "") {
        //Expressão regular para validar o CEP.
        var validacep = /^[0-9]{8}$/;

        //Valida o formato do CEP.
        if (validacep.test(cep)) {
          this.loadingCep = true;
          this.helpForm
            .post("/api/cep/pesquisar")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);

              if (en_tipo == 1) {
                this.helpForm.errors.clear();
                response.forEach((obj) => {
                  this.helpForm.emi_endereco = obj.logradouro;
                  this.helpForm.emi_bairro = obj.bairro;
                  this.helpForm.emi_complemento = obj.complemento;
                  this.optionsMunicipios.forEach((obj2) => {
                    if (obj2.ibge == obj.ibge) {
                      this.helpForm.emi_municipio = {
                        label: obj2.label,
                        value: obj2.value,
                      };
                    }
                  });
                });
              } else if (en_tipo == 2) {
                this.helpForm.errors.clear();
                response.forEach((obj) => {
                  this.helpForm.des_endereco = obj.logradouro;
                  this.helpForm.des_bairro = obj.bairro;
                  this.helpForm.des_complemento = obj.complemento;
                  this.optionsMunicipios.forEach((obj2) => {
                    if (obj2.ibge == obj.ibge) {
                      this.helpForm.des_municipio = {
                        label: obj2.label,
                        value: obj2.value,
                      };
                    }
                  });
                });
              } else if (en_tipo == 3) {
                this.form_doctransp.errors.clear();
                response.forEach((obj) => {
                  this.form_doctransp.emi_endereco = obj.logradouro;
                  this.form_doctransp.emi_bairro = obj.bairro;
                  this.form_doctransp.emi_complemento = obj.complemento;
                  this.optionsMunicipios.forEach((obj2) => {
                    if (obj2.ibge == obj.ibge) {
                      this.form_doctransp.emi_municipio = {
                        label: obj2.label,
                        value: obj2.value,
                      };
                    }
                  });
                });
              } else if (en_tipo == 4) {
                this.form_doctransp.errors.clear();
                response.forEach((obj) => {
                  this.form_doctransp.des_endereco = obj.logradouro;
                  this.form_doctransp.des_bairro = obj.bairro;
                  this.form_doctransp.des_complemento = obj.complemento;
                  this.optionsMunicipios.forEach((obj2) => {
                    if (obj2.ibge == obj.ibge) {
                      this.form_doctransp.des_municipio = {
                        label: obj2.label,
                        value: obj2.value,
                      };
                    }
                  });
                });
              }
              this.loadingCep = false;
              this.loadingCepEmi = false;
              this.loadingCepDes = false;
            })
            .catch((errors) => {
              this.loadingCep = false;
              this.loadingCepEmi = false;
              this.loadingCepDes = false;
              new ReturnApi(errors, this);
            });
        } else {
          if (en_tipo == 1) {
            var errors = { errors: { emi_cep: ["Cep inválido"] } };
            this.helpForm.errors.record(errors.errors);
          } else if (en_tipo == 2) {
            var errors = { errors: { des_cep: ["Cep inválido"] } };
            this.helpForm.errors.record(errors.errors);
          } else if (en_tipo == 3) {
            var errors = { errors: { emi_cep: ["Cep inválido"] } };
            this.form_doctransp.errors.record(errors.errors);
          } else if (en_tipo == 4) {
            var errors = { errors: { des_cep: ["Cep inválido"] } };
            this.form_doctransp.errors.record(errors.errors);
          }
        }
      }
      this.loadingCep = false;
      this.loadingCepEmi = false;
      this.loadingCepDes = false;
    },
    ajustaMascara(tipo, origem) {
      //Valor, destinatario/emitente, nfe/cte
      if (origem == 1) {
        //NFE
        if (tipo == 1) {
          //Emitente
          if (this.helpForm.emi_tp_pessoa == 1) {
            //PF
            this.mascaraEmiNfe = "###.###.###-##";
          }
          if (this.helpForm.emi_tp_pessoa == 2) {
            //PJ
            this.mascaraEmiNfe = "NN.NNN.NNN/NNNN-NN";
          }
          if (this.helpForm.emi_tp_pessoa == 3) {
            //PO
            this.mascaraEmiNfe = "XXXXXXXXXXXXXXXX";
          }
        }
        if (tipo == 2) {
          //Destinatario
          if (this.helpForm.des_tp_pessoa == 1) {
            //PF
            this.mascaraDesNfe = "###.###.###-##";
          }
          if (this.helpForm.des_tp_pessoa == 2) {
            //PJ
            this.mascaraDesNfe = "NN.NNN.NNN/NNNN-NN";
          }
          if (this.helpForm.des_tp_pessoa == 3) {
            //PO
            this.mascaraDesNfe = "XXXXXXXXXXXXXXXX";
          }
        }
      }
      if (origem == 2) {
        //CTE
        if (tipo == 2) {
          //Destinatario
          if (this.helpForm.des_tp_pessoa == 1) {
            //PF
            this.mascaraDesCte = "###.###.###-##";
          }
          if (this.helpForm.des_tp_pessoa == 2) {
            //PJ
            this.mascaraDesCte = "NN.NNN.NNN/NNNN-NN";
          }
          if (this.helpForm.des_tp_pessoa == 3) {
            //PO
            this.mascaraDesCte = "XXXXXXXXXXXXXXXX";
          }
        }
      }
    },
    addRowCompFrete: function (e) {
      e.preventDefault();
      this.comp_frete.push({
        custo: "",
        vlr: 0,
      });
    },
    removeRowCompFrete: function (index) {
      this.comp_frete.splice(index, 1);
    },
    addRowObsCont: function (e) {
      e.preventDefault();
      this.obs_cont.push({
        xcampo: "",
        xtexto: "",
      });
    },
    removeRowObsCont: function (index) {
      this.obs_cont.splice(index, 1);
    },
    addRowObsFisco: function (e) {
      e.preventDefault();
      this.obs_fisco.push({
        xcampo: "",
        xtexto: "",
      });
    },
    removeRowObsFisco: function (index) {
      this.obs_fisco.splice(index, 1);
    },
    addRowSeguro: function (e) {
      e.preventDefault();
      this.seguro.push({
        segurado_id: "",
        partprese_id: "",
      });
    },
    removeRowSeguro: function (index) {
      this.seguro.splice(index, 1);
    },
    addRowCarga: function (e) {
      e.preventDefault();
      this.carga_medida.push({
        partpmed_id: "",
        parunidmed_id: "",
        qtde_carga: 0,
      });
    },
    removeRowCarga: function (index) {
      this.carga_medida.splice(index, 1);
    },
    removeRowDoc: function (index) {
      this.docfis.splice(index, 1);
    },
    removeRowDocDig: function (index) {
      this.docfisDig.splice(index, 1);
    },
    removeRowDocTransp: function (index) {
      this.doctransp.splice(index, 1);
    },
    removeRowDocTranspDig: function (index) {
      this.doctranspDig.splice(index, 1);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatNumberQtd(value) {
      return accounting.formatNumber(value, 3, ".", ",");
    },
    formatDate(value, fmt = "D MMM YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    user: {
      get() {
        return this.$store.state.logged.user;
      },
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
    produto_predominante_left() {
      var char = this.form.produto_predominante.length,
        limit = 60;
      return limit - char + " / " + limit + " caracteres disponíveis";
    },
    obs_left() {
      var char = this.form.obs.length,
        limit = 2000;
      return limit - char + " / " + limit + " caracteres disponíveis";
    },
  },
};
</script>